// D&D 5e SRD Spell Database
export const SRD_SPELLS = {
  0: [ // Cantrips
    {
      name: "Acid Splash",
      school: "Conjuration",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Hurl a bubble of acid. Target must succeed on a Dex save or take 1d6 acid damage.",
      damage: "1d6",
      damageType: "acid",
      saveType: "dexterity",
      classes: ["Artificer", "Sorcerer", "Wizard"],
      upcastDamage: "1d6" // increases at levels 5, 11, 17
    },
    {
      name: "Blade Ward",
      school: "Abjuration",
      castTime: "1 action",
      range: "Self",
      components: "V, S",
      duration: "1 round",
      description: "You have resistance against bludgeoning, piercing, and slashing damage from weapon attacks.",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Chill Touch",
      school: "Necromancy",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "1 round",
      description: "Ranged spell attack dealing 1d8 necrotic damage and preventing healing.",
      damage: "1d8",
      damageType: "necrotic",
      saveType: "attack",
      classes: ["Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Dancing Lights",
      school: "Evocation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Create up to four torch-sized lights that hover in the air.",
      classes: ["Bard", "Sorcerer", "Wizard"]
    },
    {
      name: "Eldritch Blast",
      school: "Evocation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Ranged spell attack. 1 beam at 1st level, 2 at 5th, 3 at 11th, 4 at 17th.",
      damage: "1d10",
      damageType: "force",
      saveType: "attack",
      classes: ["Warlock"],
      multiAttack: true,
      attacksPerLevel: [1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4]
    },
    {
      name: "Fire Bolt",
      school: "Evocation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Ranged spell attack dealing 1d10 fire damage.",
      damage: "1d10",
      damageType: "fire",
      saveType: "attack",
      classes: ["Artificer", "Sorcerer", "Wizard"]
    },
    {
      name: "Guidance",
      school: "Divination",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      description: "Target can add 1d4 to one ability check of its choice.",
      spellType: "buff",
      // [PHASE B / #020 — string-sin batch 2]: Mechanical buff data
      // block, replaces the hardcoded `name === 'Guidance'` dispatch
      // at App.jsx:10876, :11180, :11181.
      appliedEffect: { bonus: '1d4' },
      classes: ["Artificer", "Cleric", "Druid"]
    },
    {
      name: "Light",
      school: "Evocation",
      castTime: "1 action",
      range: "Touch",
      components: "V, M",
      duration: "1 hour",
      description: "Object sheds bright light in 20-foot radius.",
      classes: ["Artificer", "Bard", "Cleric", "Sorcerer", "Wizard"]
    },
    {
      name: "Mage Hand",
      school: "Conjuration",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S",
      duration: "1 minute",
      description: "Create a spectral hand that can manipulate objects up to 10 pounds.",
      classes: ["Artificer", "Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Mending",
      school: "Transmutation",
      castTime: "1 minute",
      range: "Touch",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "Repair a single break or tear in an object.",
      classes: ["Artificer", "Bard", "Cleric", "Druid", "Sorcerer", "Wizard"]
    },
    {
      name: "Minor Illusion",
      school: "Illusion",
      castTime: "1 action",
      range: "30 feet",
      components: "S, M",
      duration: "1 minute",
      description: "Create a sound or image of an object.",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Poison Spray",
      school: "Conjuration",
      castTime: "1 action",
      range: "10 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Target must succeed on Constitution save or take 1d12 poison damage.",
      damage: "1d12",
      damageType: "poison",
      saveType: "constitution",
      classes: ["Artificer", "Druid", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Prestidigitation",
      school: "Transmutation",
      castTime: "1 action",
      range: "10 feet",
      components: "V, S",
      duration: "Up to 1 hour",
      description: "Minor magical tricks: sensory effects, clean/soil, chill/warm, etc.",
      classes: ["Artificer", "Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Ray of Frost",
      school: "Evocation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Ranged spell attack dealing 1d8 cold damage and reducing speed by 10 feet.",
      damage: "1d8",
      damageType: "cold",
      saveType: "attack",
      classes: ["Artificer", "Sorcerer", "Wizard"]
    },
    {
      name: "Sacred Flame",
      school: "Evocation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Target must succeed on Dexterity save or take 1d8 radiant damage.",
      damage: "1d8",
      damageType: "radiant",
      saveType: "dexterity",
      classes: ["Artificer", "Cleric"]
    },
    {
      name: "Shocking Grasp",
      school: "Evocation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "Instantaneous",
      description: "Melee spell attack dealing 1d8 lightning damage, advantage vs metal armor.",
      damage: "1d8",
      damageType: "lightning",
      saveType: "attack",
      classes: ["Artificer", "Sorcerer", "Wizard"]
    },
    {
      name: "Spare the Dying",
      school: "Necromancy",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "Instantaneous",
      description: "Stabilize a creature with 0 hit points.",
      classes: ["Artificer", "Cleric"]
    },
    {
      name: "Thaumaturgy",
      school: "Transmutation",
      castTime: "1 action",
      range: "30 feet",
      components: "V",
      duration: "Up to 1 minute",
      description: "Manifest minor wonder: loud voice, flames flicker, tremors, etc.",
      classes: ["Cleric"]
    },
    {
      name: "True Strike",
      school: "Divination",
      castTime: "1 action",
      range: "30 feet",
      components: "S",
      duration: "Concentration, up to 1 round",
      description: "Gain advantage on your next attack roll against the target.",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Vicious Mockery",
      school: "Enchantment",
      castTime: "1 action",
      range: "60 feet",
      components: "V",
      duration: "Instantaneous",
      description: "Target must succeed on Wisdom save or take 1d4 psychic damage and have disadvantage on next attack.",
      damage: "1d4",
      damageType: "psychic",
      saveType: "wisdom",
      classes: ["Bard"]
    },
    // [2025-11-25] Added missing cantrips from PHB audit
    {
      name: "Druidcraft",
      school: "Transmutation",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Create a tiny, harmless sensory effect that predicts weather, make a flower bloom, create sensory effect like leaves rustling, or light/snuff a small flame.",
      classes: ["Druid"]
    },
    {
      name: "Friends",
      school: "Enchantment",
      castTime: "1 action",
      range: "Self",
      components: "S, M",
      componentDetails: { material: "a small amount of makeup applied to the face" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Gain advantage on Charisma checks against one creature. When spell ends, creature realizes it was charmed and may become hostile.",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Message",
      school: "Transmutation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      componentDetails: { material: "a short piece of copper wire" },
      duration: "1 round",
      description: "Whisper a message to a creature within range. Target can reply in a whisper only you can hear.",
      classes: ["Artificer", "Bard", "Sorcerer", "Wizard"]
    },
    {
      name: "Produce Flame",
      school: "Conjuration",
      castTime: "1 action",
      range: "Self",
      components: "V, S",
      duration: "10 minutes",
      description: "Flickering flame appears in your hand, sheds bright light 10ft. Can hurl flame at creature within 30ft as ranged spell attack for 1d8 fire damage.",
      damage: "1d8",
      damageType: "fire",
      saveType: "attack",
      classes: ["Druid"]
    },
    {
      name: "Resistance",
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a miniature cloak" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Target can add 1d4 to one saving throw of its choice before the spell ends.",
      spellType: "buff",
      classes: ["Artificer", "Cleric", "Druid"]
    },
    {
      name: "Shillelagh",
      school: "Transmutation",
      castTime: "1 bonus action",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "mistletoe, a shamrock leaf, and a club or quarterstaff" },
      duration: "1 minute",
      description: "Club or quarterstaff becomes magical, uses spellcasting ability for attacks, and deals 1d8 damage.",
      damage: "1d8",
      damageType: "bludgeoning",
      classes: ["Druid"]
    },
    {
      name: "Thorn Whip",
      school: "Transmutation",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "the stem of a plant with thorns" },
      duration: "Instantaneous",
      description: "Create a vine-like whip covered in thorns. Melee spell attack deals 1d6 piercing and pulls creature 10ft closer if Large or smaller.",
      damage: "1d6",
      damageType: "piercing",
      saveType: "attack",
      classes: ["Artificer", "Druid"]
    }
  ],
  1: [ // Level 1
    {
      name: "Alarm",
      school: "Abjuration",
      castTime: "1 minute",
      range: "30 feet",
      components: "V, S, M",
      duration: "8 hours",
      description: "Set an alarm against unwanted intrusion.",
      ritual: true,
      classes: ["Ranger", "Wizard"]
    },
    {
      name: "Armor of Agathys",
      school: "Abjuration",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      duration: "1 hour",
      description: "Gain 5 temporary hit points and deal 5 cold damage to melee attackers.",
      classes: ["Warlock"],
      upcastEffect: "Both temp HP and damage increase by 5 per slot level above 1st."
    },
    {
      name: "Bane",
      school: "Enchantment",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Up to 3 creatures subtract 1d4 from attack rolls and saving throws.",
      saveType: "charisma",
      spellType: "debuff",
      classes: ["Bard", "Cleric"],
      concentration: true
    },
    {
      name: "Bless",
      school: "Enchantment",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Up to 3 creatures add 1d4 to attack rolls and saving throws.",
      spellType: "buff",
      // [PHASE B / #020 — string-sin batch 2]: Mechanical buff data
      // block, replaces the hardcoded `name === 'Bless'` dispatch at
      // App.jsx:10876.
      appliedEffect: { bonus: '1d4' },
      classes: ["Cleric", "Paladin"],
      concentration: true
    },
    {
      name: "Burning Hands",
      school: "Evocation",
      castTime: "1 action",
      range: "Self (15-foot cone)",
      components: "V, S",
      duration: "Instantaneous",
      description: "15-foot cone of fire. Each creature takes 3d6 fire damage on failed Dex save.",
      damage: "3d6",
      damageType: "fire",
      saveType: "dexterity",
      classes: ["Sorcerer", "Wizard"],
      upcastDamage: "1d6"
    },
    {
      name: "Charm Person",
      school: "Enchantment",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S",
      duration: "1 hour",
      description: "Target humanoid regards you as a friendly acquaintance if it fails Wisdom save.",
      saveType: "wisdom",
      classes: ["Bard", "Druid", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Chromatic Orb",
      school: "Evocation",
      castTime: "1 action",
      range: "90 feet",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "Ranged spell attack dealing 3d8 damage of chosen type.",
      damage: "3d8",
      damageType: "variable",
      saveType: "attack",
      classes: ["Sorcerer", "Wizard"],
      upcastDamage: "1d8"
    },
    {
      name: "Command",
      school: "Enchantment",
      castTime: "1 action",
      range: "60 feet",
      components: "V",
      duration: "1 round",
      description: "Target obeys one-word command on failed Wisdom save.",
      saveType: "wisdom",
      classes: ["Cleric", "Paladin"]
    },
    {
      name: "Comprehend Languages",
      school: "Divination",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      duration: "1 hour",
      description: "Understand any spoken or written language.",
      ritual: true,
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Cure Wounds",
      school: "Evocation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "Instantaneous",
      description: "Heal a creature for 1d8 + spellcasting modifier.",
      healing: "1d8",
      spellType: "healing",
      classes: ["Bard", "Cleric", "Druid", "Paladin", "Ranger"],
      upcastDamage: "1d8"
    },
    {
      name: "Detect Magic",
      school: "Divination",
      castTime: "1 action",
      range: "Self",
      components: "V, S",
      duration: "Concentration, up to 10 minutes",
      description: "Sense magic within 30 feet and learn its school.",
      ritual: true,
      concentration: true,
      classes: ["Bard", "Cleric", "Druid", "Paladin", "Ranger", "Sorcerer", "Wizard"]
    },
    {
      name: "Disguise Self",
      school: "Illusion",
      castTime: "1 action",
      range: "Self",
      components: "V, S",
      duration: "1 hour",
      description: "Change your appearance including clothing and equipment.",
      classes: ["Bard", "Sorcerer", "Wizard"]
    },
    {
      name: "Faerie Fire",
      school: "Evocation",
      castTime: "1 action",
      range: "60 feet",
      components: "V",
      duration: "Concentration, up to 1 minute",
      description: "Objects in 20-foot cube are outlined in light, attacks have advantage.",
      saveType: "dexterity",
      concentration: true,
      classes: ["Bard", "Druid"]
    },
    {
      name: "False Life",
      school: "Necromancy",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      duration: "1 hour",
      description: "Gain 1d4 + 4 temporary hit points.",
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Feather Fall",
      school: "Transmutation",
      castTime: "1 reaction",
      range: "60 feet",
      components: "V, M",
      duration: "1 minute",
      description: "Up to 5 creatures fall slowly for 1 minute.",
      classes: ["Bard", "Sorcerer", "Wizard"]
    },
    {
      name: "Find Familiar",
      school: "Conjuration",
      castTime: "1 hour",
      range: "10 feet",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "Summon a spirit that takes the form of an animal companion.",
      ritual: true,
      classes: ["Wizard"]
    },
    {
      name: "Fog Cloud",
      school: "Conjuration",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Concentration, up to 1 hour",
      description: "Create 20-foot radius sphere of fog that heavily obscures the area.",
      concentration: true,
      classes: ["Druid", "Ranger", "Sorcerer", "Wizard"]
    },
    {
      name: "Grease",
      school: "Conjuration",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "1 minute",
      description: "10-foot square becomes difficult terrain, creatures may fall prone.",
      saveType: "dexterity",
      classes: ["Wizard"]
    },
    {
      name: "Guiding Bolt",
      school: "Evocation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "1 round",
      description: "Ranged spell attack dealing 4d6 radiant damage, next attack has advantage.",
      damage: "4d6",
      damageType: "radiant",
      saveType: "attack",
      classes: ["Cleric"],
      upcastDamage: "1d6"
    },
    {
      name: "Healing Word",
      school: "Evocation",
      castTime: "1 bonus action",
      range: "60 feet",
      components: "V",
      duration: "Instantaneous",
      description: "Heal a creature for 1d4 + spellcasting modifier.",
      healing: "1d4",
      spellType: "healing",
      classes: ["Bard", "Cleric", "Druid"],
      upcastDamage: "1d4"
    },
    {
      name: "Hellish Rebuke",
      school: "Evocation",
      castTime: "1 reaction",
      range: "60 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Creature that damaged you takes 2d10 fire damage on failed Dex save.",
      damage: "2d10",
      damageType: "fire",
      saveType: "dexterity",
      classes: ["Warlock"],
      upcastDamage: "1d10"
    },
    {
      name: "Hex",
      school: "Enchantment",
      castTime: "1 bonus action",
      range: "90 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 hour",
      description: "Target takes extra 1d6 necrotic damage, disadvantage on one ability.",
      damage: "1d6",
      damageType: "necrotic",
      spellType: "debuff",
      concentration: true,
      classes: ["Warlock"]
    },
    {
      name: "Hunter's Mark",
      school: "Divination",
      castTime: "1 bonus action",
      range: "90 feet",
      components: "V",
      duration: "Concentration, up to 1 hour",
      description: "Deal extra 1d6 damage to target, advantage on tracking.",
      damage: "1d6",
      concentration: true,
      classes: ["Ranger"],
      // [PHASE B / #035 — 2026-05-06]: Surfaces the
      //   `huntersMarkTargetActive` combat toggle whenever this spell
      //   is in the player's known/prepared list — Ranger class spell,
      //   Magic Initiate (Druid/Ranger), spell scroll, or any other
      //   path that adds the spell. Closes the string-match
      //   `s.name === "Hunter's Mark"` anti-pattern in
      //   src/data/combatToggles.js.
      surfacesCombatToggle: 'huntersMarkTargetActive',
    },
    // [2025-11-25] Missing PHB Ranger/Paladin combat spells
    {
      name: "Ensnaring Strike",
      school: "Conjuration",
      castTime: "1 bonus action",
      range: "Self",
      components: "V",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Next hit causes thorny vines to restrain target. Large or smaller creature makes Str save or is restrained and takes 1d6 piercing at start of each turn.",
      damage: "1d6",
      damageType: "piercing",
      saveType: "strength",
      classes: ["Ranger"],
      upcastDamage: "1d6"
    },
    {
      name: "Hail of Thorns",
      school: "Conjuration",
      castTime: "1 bonus action",
      range: "Self",
      components: "V",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Next ranged weapon hit causes thorns to explode. Target and creatures within 5 feet take 1d10 piercing damage (Dex save for half).",
      damage: "1d10",
      damageType: "piercing",
      saveType: "dexterity",
      classes: ["Ranger"],
      upcastDamage: "1d10"
    },
    {
      name: "Compelled Duel",
      school: "Enchantment",
      castTime: "1 bonus action",
      range: "30 feet",
      components: "V",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Target must make Wis save or be drawn to you. It has disadvantage on attacks against others, and must make Wis save to move more than 30 feet from you.",
      saveType: "wisdom",
      classes: ["Paladin"]
    },
    {
      name: "Identify",
      school: "Divination",
      castTime: "1 minute",
      range: "Touch",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "Learn properties of magic item or spell affecting a creature.",
      ritual: true,
      classes: ["Bard", "Wizard"]
    },
    {
      name: "Illusory Script",
      school: "Illusion",
      castTime: "1 minute",
      range: "Touch",
      components: "S, M",
      duration: "10 days",
      description: "Write a message that appears different to other creatures.",
      ritual: true,
      classes: ["Bard", "Warlock", "Wizard"]
    },
    {
      name: "Inflict Wounds",
      school: "Necromancy",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "Instantaneous",
      description: "Melee spell attack dealing 3d10 necrotic damage.",
      damage: "3d10",
      damageType: "necrotic",
      saveType: "attack",
      classes: ["Cleric"],
      upcastDamage: "1d10"
    },
    {
      name: "Jump",
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "1 minute",
      description: "Triple creature's jump distance.",
      classes: ["Druid", "Ranger", "Sorcerer", "Wizard"]
    },
    {
      name: "Longstrider",
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "1 hour",
      description: "Target's speed increases by 10 feet.",
      classes: ["Bard", "Druid", "Ranger", "Wizard"]
    },
    {
      name: "Mage Armor",
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "8 hours",
      description: "Target's base AC becomes 13 + Dexterity modifier.",
      spellType: "buff",
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Magic Missile",
      school: "Evocation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Three darts deal 1d4 + 1 force damage each, auto-hit.",
      damage: "1d4+1",
      damageType: "force",
      autoHit: true, // [FIX APR 2026 — F-20]: Property-based auto-hit detection
      classes: ["Sorcerer", "Wizard"],
      upcastDamage: "1d4+1",
      upcastEffect: "One additional dart per slot level above 1st."
    },
    {
      name: "Protection from Evil and Good",
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "Concentration, up to 10 minutes",
      description: "Protection against aberrations, celestials, elementals, fey, fiends, undead.",
      spellType: "buff",
      concentration: true,
      classes: ["Cleric", "Paladin", "Warlock", "Wizard"]
    },
    {
      name: "Sanctuary",
      school: "Abjuration",
      castTime: "1 bonus action",
      range: "30 feet",
      components: "V, S, M",
      duration: "1 minute",
      description: "Attackers must make Wisdom save to target protected creature.",
      saveType: "wisdom",
      classes: ["Cleric"]
    },
    {
      name: "Shield",
      school: "Abjuration",
      castTime: "1 reaction",
      range: "Self",
      components: "V, S",
      duration: "1 round",
      description: "+5 bonus to AC until start of next turn.",
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Shield of Faith",
      school: "Abjuration",
      castTime: "1 bonus action",
      range: "60 feet",
      components: "V, S, M",
      duration: "Concentration, up to 10 minutes",
      description: "Target gains +2 bonus to AC.",
      spellType: "buff",
      concentration: true,
      classes: ["Cleric", "Paladin"]
    },
    {
      name: "Silent Image",
      school: "Illusion",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "Concentration, up to 10 minutes",
      description: "Create image of object, creature, or phenomenon no larger than 15-foot cube.",
      concentration: true,
      classes: ["Bard", "Sorcerer", "Wizard"]
    },
    {
      name: "Sleep",
      school: "Enchantment",
      castTime: "1 action",
      range: "90 feet",
      components: "V, S, M",
      duration: "1 minute",
      description: "Roll 5d8; creatures within 20 feet fall unconscious in order of lowest HP.",
      classes: ["Bard", "Sorcerer", "Wizard"],
      upcastEffect: "Roll an additional 2d8 per slot level above 1st."
    },
    {
      name: "Speak with Animals",
      school: "Divination",
      castTime: "1 action",
      range: "Self",
      components: "V, S",
      duration: "10 minutes",
      description: "Communicate with beasts.",
      ritual: true,
      classes: ["Bard", "Druid", "Ranger"]
    },
    {
      name: "Tasha's Hideous Laughter",
      school: "Enchantment",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Target falls prone, incapacitated with laughter on failed Wisdom save.",
      saveType: "wisdom",
      concentration: true,
      classes: ["Bard", "Wizard"]
    },
    {
      name: "Thunderwave",
      school: "Evocation",
      castTime: "1 action",
      range: "Self (15-foot cube)",
      components: "V, S",
      duration: "Instantaneous",
      description: "2d8 thunder damage and push 10 feet on failed Con save.",
      damage: "2d8",
      damageType: "thunder",
      saveType: "constitution",
      classes: ["Bard", "Druid", "Sorcerer", "Wizard"],
      upcastDamage: "1d8"
    },
    {
      name: "Unseen Servant",
      school: "Conjuration",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "1 hour",
      description: "Create invisible force that performs simple tasks.",
      ritual: true,
      classes: ["Bard", "Warlock", "Wizard"]
    },
    {
      name: "Witch Bolt",
      school: "Evocation",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Ranged spell attack dealing 1d12 lightning damage, can repeat as action.",
      damage: "1d12",
      damageType: "lightning",
      saveType: "attack",
      concentration: true,
      classes: ["Sorcerer", "Warlock", "Wizard"],
      upcastDamage: "1d12"
    },
    // [2025-11-25] Added missing 1st level spells from PHB audit
    {
      name: "Animal Friendship",
      school: "Enchantment",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "a morsel of food" },
      duration: "24 hours",
      description: "Convince a beast that you mean it no harm. Wisdom save or charmed for duration. Creatures with INT 4+ automatically succeed.",
      saveType: "wisdom",
      classes: ["Bard", "Druid", "Ranger"]
    },
    {
      name: "Arms of Hadar",
      school: "Conjuration",
      castTime: "1 action",
      range: "Self (10-foot radius)",
      components: "V, S",
      duration: "Instantaneous",
      description: "Tendrils of dark energy erupt from you. Each creature within 10 feet must make Strength save or take 2d6 necrotic damage and can't take reactions until next turn.",
      damage: "2d6",
      damageType: "necrotic",
      saveType: "strength",
      classes: ["Warlock"],
      upcastDamage: "1d6"
    },
    {
      name: "Color Spray",
      school: "Illusion",
      castTime: "1 action",
      range: "Self (15-foot cone)",
      components: "V, S, M",
      componentDetails: { material: "a pinch of powder or sand colored red, yellow, and blue" },
      duration: "1 round",
      description: "Roll 6d10; creatures in cone are blinded starting with lowest HP until HP total exceeded.",
      classes: ["Sorcerer", "Wizard"],
      upcastEffect: "2d10 additional HP affected per slot level above 1st"
    },
    {
      name: "Create or Destroy Water",
      school: "Transmutation",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "a drop of water if creating water, or a few grains of sand if destroying it" },
      duration: "Instantaneous",
      description: "Create up to 10 gallons of clean water, or destroy up to 10 gallons of water in an open container.",
      classes: ["Cleric", "Druid"],
      upcastEffect: "10 additional gallons per slot level above 1st"
    },
    {
      name: "Detect Evil and Good",
      school: "Divination",
      castTime: "1 action",
      range: "Self",
      components: "V, S",
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Know if aberration, celestial, elemental, fey, fiend, or undead is within 30 feet, and where the creature is located.",
      classes: ["Cleric", "Paladin"]
    },
    {
      name: "Detect Poison and Disease",
      school: "Divination",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "a yew leaf" },
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      ritual: true,
      description: "Sense presence of poisons, poisonous creatures, and diseases within 30 feet. Also identify the kind.",
      classes: ["Cleric", "Druid", "Paladin", "Ranger"]
    },
    {
      name: "Dissonant Whispers",
      school: "Enchantment",
      castTime: "1 action",
      range: "60 feet",
      components: "V",
      duration: "Instantaneous",
      description: "Whisper discordant melody. Target makes Wisdom save or takes 3d6 psychic damage and must use reaction to move away. Half damage on success.",
      damage: "3d6",
      damageType: "psychic",
      saveType: "wisdom",
      classes: ["Bard"],
      upcastDamage: "1d6"
    },
    {
      name: "Divine Favor",
      school: "Evocation",
      castTime: "1 bonus action",
      range: "Self",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Your weapon attacks deal an extra 1d4 radiant damage on a hit.",
      classes: ["Paladin"]
    },
    {
      name: "Entangle",
      school: "Conjuration",
      castTime: "1 action",
      range: "90 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Grasping weeds and vines sprout from ground in 20-foot square. Creatures must make Strength save or be restrained. Difficult terrain.",
      saveType: "strength",
      classes: ["Druid"]
    },
    {
      name: "Expeditious Retreat",
      school: "Transmutation",
      castTime: "1 bonus action",
      range: "Self",
      components: "V, S",
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Take Dash action as bonus action on each turn for the duration.",
      classes: ["Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Goodberry",
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a sprig of mistletoe" },
      duration: "Instantaneous",
      description: "Create 10 magical berries. Eating a berry restores 1 HP and provides enough nourishment for a day.",
      classes: ["Druid", "Ranger"]
    },
    {
      name: "Heroism",
      school: "Enchantment",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Willing creature is immune to being frightened and gains temporary HP equal to your spellcasting modifier at start of each turn.",
      spellType: "buff",
      classes: ["Bard", "Paladin"],
      upcastEffect: "Target one additional creature per slot level above 1st"
    },
    {
      name: "Purify Food and Drink",
      school: "Transmutation",
      castTime: "1 action",
      range: "10 feet",
      components: "V, S",
      duration: "Instantaneous",
      ritual: true,
      description: "All nonmagical food and drink within a 5-foot-radius sphere is rendered free of poison and disease.",
      classes: ["Cleric", "Druid", "Paladin"]
    },
    {
      name: "Ray of Sickness",
      school: "Necromancy",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Ranged spell attack deals 2d8 poison damage. On hit, target must make Constitution save or be poisoned until end of your next turn.",
      damage: "2d8",
      damageType: "poison",
      saveType: "attack",
      classes: ["Sorcerer", "Wizard"],
      upcastDamage: "1d8"
    },
    {
      name: "Searing Smite",
      school: "Evocation",
      castTime: "1 bonus action",
      range: "Self",
      components: "V",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Next weapon hit deals extra 1d6 fire damage and sets target on fire, taking 1d6 fire at start of each turn until Constitution save.",
      damage: "1d6",
      damageType: "fire",
      saveType: "constitution",
      classes: ["Paladin"],
      upcastDamage: "1d6"
    },
    {
      name: "Thunderous Smite",
      school: "Evocation",
      castTime: "1 bonus action",
      range: "Self",
      components: "V",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Next weapon hit deals extra 2d6 thunder damage. Target makes Strength save or pushed 10 feet and knocked prone.",
      damage: "2d6",
      damageType: "thunder",
      saveType: "strength",
      classes: ["Paladin"]
    },
    {
      name: "Wrathful Smite",
      school: "Evocation",
      castTime: "1 bonus action",
      range: "Self",
      components: "V",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Next weapon hit deals extra 1d6 psychic damage. Target makes Wisdom save or frightened of you until spell ends.",
      damage: "1d6",
      damageType: "psychic",
      saveType: "wisdom",
      classes: ["Paladin"]
    }
  ],
  2: [ // Level 2
    {
      name: "Aid",
      school: "Abjuration",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      duration: "8 hours",
      description: "Choose up to three creatures within range. Each target's hit point maximum and current hit points increase by 5 for the duration.",
      spellType: "buff",
      classes: ["Cleric", "Paladin"],
      upcastEffect: "5 additional HP per slot level above 2nd."
    },
    {
      name: "Alter Self",
      school: "Transmutation",
      castTime: "1 action",
      range: "Self",
      components: "V, S",
      duration: "Concentration, up to 1 hour",
      description: "Change appearance, adapt to environment, or grow natural weapons.",
      concentration: true,
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Arcane Lock",
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "Until dispelled",
      description: "Lock becomes harder to break or pick (DC +10).",
      classes: ["Wizard"]
    },
    {
      name: "Augury",
      school: "Divination",
      castTime: "1 minute",
      range: "Self",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "Learn if action will have good, bad, or mixed results.",
      ritual: true,
      classes: ["Cleric"]
    },
    {
      name: "Barkskin",
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "Concentration, up to 1 hour",
      description: "Target's AC can't be less than 16.",
      spellType: "buff",
      concentration: true,
      classes: ["Druid", "Ranger"]
    },
    {
      name: "Blindness/Deafness",
      school: "Necromancy",
      castTime: "1 action",
      range: "30 feet",
      components: "V",
      duration: "1 minute",
      description: "Blind or deafen a creature on failed Constitution save.",
      saveType: "constitution",
      spellType: "debuff",
      classes: ["Bard", "Cleric", "Sorcerer", "Wizard"]
    },
    {
      name: "Blur",
      school: "Illusion",
      castTime: "1 action",
      range: "Self",
      components: "V",
      duration: "Concentration, up to 1 minute",
      description: "Attacks against you have disadvantage.",
      spellType: "buff",
      concentration: true,
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Calm Emotions",
      school: "Enchantment",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      description: "Suppress strong emotions in a 20-foot radius sphere.",
      saveType: "charisma",
      concentration: true,
      classes: ["Bard", "Cleric"]
    },
    {
      name: "Cloud of Daggers",
      school: "Conjuration",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "5-foot cube deals 4d4 slashing damage.",
      damage: "4d4",
      damageType: "slashing",
      concentration: true,
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
      upcastDamage: "2d4"
    },
    {
      name: "Darkness",
      school: "Evocation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, M",
      duration: "Concentration, up to 10 minutes",
      description: "15-foot radius of magical darkness.",
      concentration: true,
      classes: ["Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Darkvision",
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "8 hours",
      description: "Grant darkvision out to 60 feet.",
      classes: ["Druid", "Ranger", "Sorcerer", "Wizard"]
    },
    {
      name: "Detect Thoughts",
      school: "Divination",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Read surface thoughts, probe deeper with save.",
      saveType: "wisdom",
      concentration: true,
      classes: ["Bard", "Sorcerer", "Wizard"]
    },
    {
      name: "Enhance Ability",
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "Concentration, up to 1 hour",
      description: "Grant advantage on one type of ability check.",
      spellType: "buff",
      // [PHASE B / #020 — string-sin batch 2]: Mechanical buff data
      // block, replaces the hardcoded `name === 'Enhance Ability'`
      // dispatch at App.jsx:10875.
      appliedEffect: { advantage: true },
      concentration: true,
      classes: ["Bard", "Cleric", "Druid", "Sorcerer"]
    },
    {
      name: "Enlarge/Reduce",
      school: "Transmutation",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Double or halve size of creature or object.",
      saveType: "constitution",
      concentration: true,
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Enthrall",
      school: "Enchantment",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "1 minute",
      description: "Creatures have disadvantage on Perception checks to notice anyone but you.",
      saveType: "wisdom",
      classes: ["Bard", "Warlock"]
    },
    {
      name: "Find Traps",
      school: "Divination",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Learn presence but not location of traps.",
      classes: ["Cleric", "Druid", "Ranger"]
    },
    {
      name: "Flame Blade",
      school: "Evocation",
      castTime: "1 bonus action",
      range: "Self",
      components: "V, S, M",
      duration: "Concentration, up to 10 minutes",
      description: "Wield a flaming blade dealing 3d6 fire damage.",
      damage: "3d6",
      damageType: "fire",
      concentration: true,
      classes: ["Druid"]
    },
    {
      name: "Flaming Sphere",
      school: "Conjuration",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "5-foot sphere deals 2d6 fire damage, can move as bonus action.",
      damage: "2d6",
      damageType: "fire",
      saveType: "dexterity",
      concentration: true,
      classes: ["Druid", "Wizard"],
      upcastDamage: "1d6"
    },
    {
      name: "Gentle Repose",
      school: "Necromancy",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "10 days",
      description: "Preserve corpse, extend time limit for raising dead.",
      ritual: true,
      classes: ["Cleric", "Wizard"]
    },
    {
      name: "Heat Metal",
      school: "Transmutation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Heat metal object, dealing 2d8 fire damage to holder.",
      damage: "2d8",
      damageType: "fire",
      saveType: "constitution",
      concentration: true,
      classes: ["Bard", "Druid"],
      upcastDamage: "1d8"
    },
    {
      name: "Hold Person",
      school: "Enchantment",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Paralyze humanoid on failed Wisdom save.",
      saveType: "wisdom",
      spellType: "control",
      concentration: true,
      classes: ["Bard", "Cleric", "Druid", "Sorcerer", "Warlock", "Wizard"],
      upcastEffect: "Target one additional humanoid per slot level above 2nd."
    },
    {
      name: "Invisibility",
      school: "Illusion",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "Concentration, up to 1 hour",
      description: "Creature becomes invisible until it attacks or casts.",
      spellType: "buff",
      concentration: true,
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
      upcastEffect: "Target one additional creature per slot level above 2nd."
    },
    {
      name: "Knock",
      school: "Transmutation",
      castTime: "1 action",
      range: "60 feet",
      components: "V",
      duration: "Instantaneous",
      description: "Open locked or magically sealed object.",
      classes: ["Bard", "Sorcerer", "Wizard"]
    },
    {
      name: "Lesser Restoration",
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "Instantaneous",
      description: "End one disease or condition: blinded, deafened, paralyzed, or poisoned.",
      classes: ["Bard", "Cleric", "Druid", "Paladin", "Ranger"]
    },
    {
      name: "Levitate",
      school: "Transmutation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "Concentration, up to 10 minutes",
      description: "Rise vertically up to 20 feet, move up/down as action.",
      saveType: "constitution",
      concentration: true,
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Magic Mouth",
      school: "Illusion",
      castTime: "1 minute",
      range: "30 feet",
      components: "V, S, M",
      duration: "Until dispelled",
      description: "Implant message triggered by conditions.",
      ritual: true,
      classes: ["Bard", "Wizard"]
    },
    {
      name: "Magic Weapon",
      school: "Transmutation",
      castTime: "1 bonus action",
      range: "Touch",
      components: "V, S",
      duration: "Concentration, up to 1 hour",
      description: "Weapon becomes magical with +1 bonus.",
      concentration: true,
      classes: ["Paladin", "Wizard"]
    },
    {
      name: "Mirror Image",
      school: "Illusion",
      castTime: "1 action",
      range: "Self",
      components: "V, S",
      duration: "1 minute",
      description: "Create 3 illusory duplicates, attacks may hit them instead.",
      spellType: "buff",
      classes: ["Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Misty Step",
      school: "Conjuration",
      castTime: "1 bonus action",
      range: "Self",
      components: "V",
      duration: "Instantaneous",
      description: "Teleport up to 30 feet to unoccupied space you can see.",
      classes: ["Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Moonbeam",
      school: "Evocation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "5-foot cylinder deals 2d10 radiant damage, can move as action.",
      damage: "2d10",
      damageType: "radiant",
      saveType: "constitution",
      concentration: true,
      classes: ["Druid"],
      upcastDamage: "1d10"
    },
    {
      name: "Pass without Trace",
      school: "Abjuration",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      duration: "Concentration, up to 1 hour",
      description: "+10 bonus to Stealth checks, can't be tracked except by magic.",
      concentration: true,
      classes: ["Druid", "Ranger"]
    },
    {
      name: "Prayer of Healing",
      school: "Evocation",
      castTime: "10 minutes",
      range: "30 feet",
      components: "V",
      duration: "Instantaneous",
      description: "Up to 6 creatures heal 2d8 + spellcasting modifier.",
      healing: "2d8",
      spellType: "healing",
      classes: ["Cleric"],
      upcastDamage: "1d8"
    },
    {
      name: "Protection from Poison",
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "1 hour",
      description: "Neutralize one poison, advantage on saves vs poison, resistance to poison damage.",
      spellType: "buff",
      classes: ["Cleric", "Druid", "Paladin", "Ranger"]
    },
    {
      name: "Ray of Enfeeblement",
      school: "Necromancy",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      description: "Target deals half damage with Strength-based attacks.",
      saveType: "constitution",
      concentration: true,
      classes: ["Warlock", "Wizard"]
    },
    {
      name: "Rope Trick",
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "1 hour",
      description: "Rope leads to extradimensional space for 8 creatures.",
      classes: ["Wizard"]
    },
    {
      name: "Scorching Ray",
      school: "Evocation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Three rays, ranged spell attack, 2d6 fire damage each.",
      damage: "2d6",
      damageType: "fire",
      saveType: "attack",
      classes: ["Sorcerer", "Wizard"],
      upcastDamage: "2d6",
      upcastEffect: "One additional ray per slot level above 2nd."
    },
    {
      name: "See Invisibility",
      school: "Divination",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      duration: "1 hour",
      description: "See invisible creatures and objects, see into Ethereal Plane.",
      classes: ["Bard", "Sorcerer", "Wizard"]
    },
    {
      name: "Shatter",
      school: "Evocation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "10-foot radius sphere, 3d8 thunder damage.",
      damage: "3d8",
      damageType: "thunder",
      saveType: "constitution",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
      upcastDamage: "1d8"
    },
    {
      name: "Silence",
      school: "Illusion",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Concentration, up to 10 minutes",
      description: "20-foot radius sphere of silence, no sound can pass through.",
      concentration: true,
      ritual: true,
      classes: ["Bard", "Cleric", "Ranger"]
    },
    {
      name: "Spider Climb",
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "Concentration, up to 1 hour",
      description: "Move on walls and ceilings, hands free.",
      concentration: true,
      classes: ["Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Spike Growth",
      school: "Transmutation",
      castTime: "1 action",
      range: "150 feet",
      components: "V, S, M",
      duration: "Concentration, up to 10 minutes",
      description: "20-foot radius difficult terrain, 2d4 piercing per 5 feet moved.",
      damage: "2d4",
      damageType: "piercing",
      concentration: true,
      classes: ["Druid", "Ranger"]
    },
    {
      name: "Spiritual Weapon",
      school: "Evocation",
      castTime: "1 bonus action",
      range: "60 feet",
      components: "V, S",
      duration: "1 minute",
      description: "Create floating weapon, 1d8 + spellcasting force damage.",
      damage: "1d8",
      damageType: "force",
      saveType: "attack",
      classes: ["Cleric"],
      upcastDamage: "1d8" // per 2 slot levels
    },
    {
      name: "Suggestion",
      school: "Enchantment",
      castTime: "1 action",
      range: "30 feet",
      components: "V, M",
      duration: "Concentration, up to 8 hours",
      description: "Suggest course of action, target follows if reasonable.",
      saveType: "wisdom",
      concentration: true,
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Warding Bond",
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "1 hour",
      description: "Target gains +1 AC, +1 saves, resistance to all damage; you take same damage.",
      classes: ["Cleric"]
    },
    {
      name: "Web",
      school: "Conjuration",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 hour",
      description: "20-foot cube of webbing restrains creatures.",
      saveType: "dexterity",
      concentration: true,
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Zone of Truth",
      school: "Enchantment",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "10 minutes",
      description: "15-foot radius, creatures can't lie on failed Charisma save.",
      saveType: "charisma",
      classes: ["Bard", "Cleric", "Paladin"]
    },
    // [2025-11-25] Added missing 2nd level spells from PHB audit
    {
      name: "Animal Messenger",
      school: "Enchantment",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "a morsel of food" },
      duration: "24 hours",
      ritual: true,
      description: "Use a Tiny beast to deliver a message. Beast travels 50 miles per 24 hours (flying) or 25 miles (otherwise).",
      classes: ["Bard", "Druid", "Ranger"],
      upcastEffect: "Duration increases by 48 hours per slot level above 2nd"
    },
    {
      name: "Beast Sense",
      school: "Divination",
      castTime: "1 action",
      range: "Touch",
      components: "S",
      duration: "Concentration, up to 1 hour",
      concentration: true,
      ritual: true,
      description: "Touch a willing beast. You can use your action to see through its eyes and hear what it hears.",
      classes: ["Druid", "Ranger"]
    },
    {
      name: "Branding Smite",
      school: "Evocation",
      castTime: "1 bonus action",
      range: "Self",
      components: "V",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Next weapon hit deals extra 2d6 radiant damage. Target sheds dim light in 5-foot radius and can't become invisible.",
      damage: "2d6",
      damageType: "radiant",
      classes: ["Paladin"],
      upcastDamage: "1d6"
    },
    {
      name: "Continual Flame",
      school: "Evocation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "ruby dust worth 50 gp, which the spell consumes", consumed: true, cost: 50 },
      duration: "Until dispelled",
      description: "A flame springs forth from an object. Sheds bright light in 20-foot radius and dim light for additional 20 feet.",
      classes: ["Cleric", "Wizard"]
    },
    {
      name: "Crown of Madness",
      school: "Enchantment",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Humanoid must make Wisdom save or be charmed. While charmed, twisted crown of jagged iron appears on head and must attack creature you designate before moving.",
      saveType: "wisdom",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Find Steed",
      school: "Conjuration",
      castTime: "10 minutes",
      range: "30 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Summon a spirit that takes the form of a loyal steed: warhorse, pony, camel, elk, or mastiff. You have telepathic bond with your steed.",
      classes: ["Paladin"]
    },
    {
      name: "Cordon of Arrows",
      school: "Transmutation",
      castTime: "1 action",
      range: "5 feet",
      components: "V, S, M",
      componentDetails: { material: "four or more arrows or bolts" },
      duration: "8 hours",
      description: "Plant 4 pieces of ammunition in ground within range. When creature other than you comes within 30 feet, one piece flies at it: Dex save or 1d6 piercing damage. Spell ends when no ammunition remains.",
      damage: "1d6",
      damageType: "piercing",
      saveType: "dexterity",
      classes: ["Ranger"],
      upcastEffect: "+2 pieces of ammunition per level above 2nd."
    },
    {
      name: "Gust of Wind",
      school: "Evocation",
      castTime: "1 action",
      range: "Self (60-foot line)",
      components: "V, S, M",
      componentDetails: { material: "a legume seed" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "60-foot line of strong wind blasts from you. Creatures must make Strength save or be pushed 15 feet away. Area is difficult terrain.",
      saveType: "strength",
      classes: ["Druid", "Sorcerer", "Wizard"]
    },
    {
      name: "Locate Animals or Plants",
      school: "Divination",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "a bit of fur from a bloodhound" },
      duration: "Instantaneous",
      ritual: true,
      description: "Name a specific kind of beast or plant. Learn direction and distance to closest creature or plant of that kind within 5 miles.",
      classes: ["Bard", "Druid", "Ranger"]
    },
    {
      name: "Locate Object",
      school: "Divination",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "a forked twig" },
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Describe or name a specific object familiar to you. Learn direction to the object if within 1,000 feet.",
      classes: ["Bard", "Cleric", "Druid", "Paladin", "Ranger", "Wizard"]
    },
    {
      name: "Phantasmal Force",
      school: "Illusion",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      componentDetails: { material: "a bit of fleece" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Craft an illusion in target's mind. Intelligence save or target perceives illusion as real, takes 1d6 psychic damage per turn, and rationalizes illogical outcomes.",
      damage: "1d6",
      damageType: "psychic",
      saveType: "intelligence",
      classes: ["Bard", "Sorcerer", "Wizard"]
    }
  ],
  3: [ // Level 3 - Sample spells
    {
      name: "Blink",
      school: "Transmutation",
      castTime: "1 action",
      range: "Self",
      components: "V, S",
      duration: "1 minute",
      description: "Roll d20 at end of each turn. On 11+, vanish to Ethereal Plane until start of next turn. While there, see/hear the plane you came from in grayscale within 60 feet, but can't affect or be affected by anything on that plane.",
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Counterspell",
      school: "Abjuration",
      castTime: "1 reaction",
      range: "60 feet",
      components: "S",
      duration: "Instantaneous",
      description: "Interrupt a creature casting a spell of 3rd level or lower.",
      classes: ["Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Dispel Magic",
      school: "Abjuration",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "End spells of 3rd level or lower on target.",
      classes: ["Bard", "Cleric", "Druid", "Paladin", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Fireball",
      school: "Evocation",
      castTime: "1 action",
      range: "150 feet",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "20-foot radius sphere, 8d6 fire damage.",
      damage: "8d6",
      damageType: "fire",
      saveType: "dexterity",
      classes: ["Sorcerer", "Wizard"],
      upcastDamage: "1d6"
    },
    {
      name: "Fly",
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "Concentration, up to 10 minutes",
      description: "Target gains flying speed of 60 feet.",
      concentration: true,
      classes: ["Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Haste",
      school: "Transmutation",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Double speed, +2 AC, advantage on Dex saves, additional action.",
      spellType: "buff",
      concentration: true,
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Lightning Bolt",
      school: "Evocation",
      castTime: "1 action",
      range: "Self (100-foot line)",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "100-foot line, 8d6 lightning damage.",
      damage: "8d6",
      damageType: "lightning",
      saveType: "dexterity",
      classes: ["Sorcerer", "Wizard"],
      upcastDamage: "1d6"
    },
    {
      name: "Revivify",
      school: "Necromancy",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "Return creature that died within 1 minute to life with 1 HP.",
      classes: ["Cleric", "Paladin"]
    },
    {
      name: "Slow",
      school: "Transmutation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Up to 6 creatures halved speed, -2 AC, -2 Dex saves.",
      saveType: "wisdom",
      spellType: "debuff",
      concentration: true,
      classes: ["Sorcerer", "Wizard"]
    },
    // [2025-11-25] Added missing 3rd level spells from PHB audit
    {
      name: "Blinding Smite",
      school: "Evocation",
      castTime: "1 bonus action",
      range: "Self",
      components: "V",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Next weapon hit deals extra 3d8 radiant damage. Target makes Constitution save or is blinded until spell ends.",
      damage: "3d8",
      damageType: "radiant",
      saveType: "constitution",
      classes: ["Paladin"]
    },
    {
      name: "Call Lightning",
      school: "Conjuration",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Summon storm cloud. Call lightning bolts dealing 3d10 lightning damage (Dex save for half). Outdoors in storm, damage is 4d10.",
      damage: "3d10",
      damageType: "lightning",
      saveType: "dexterity",
      classes: ["Druid"],
      upcastDamage: "1d10"
    },
    // [2025-11-25] Missing PHB 3rd level Ranger/Paladin spells
    {
      name: "Conjure Barrage",
      school: "Conjuration",
      castTime: "1 action",
      range: "Self (60-foot cone)",
      components: "V, S, M",
      componentDetails: { material: "one piece of ammunition or a thrown weapon" },
      duration: "Instantaneous",
      description: "Throw nonmagical weapon or fire ammunition to create cone of duplicates. Each creature in 60-foot cone makes Dex save or takes 3d8 damage of weapon's type.",
      damage: "3d8",
      damageType: "piercing",
      saveType: "dexterity",
      classes: ["Ranger"]
    },
    {
      name: "Lightning Arrow",
      school: "Transmutation",
      castTime: "1 bonus action",
      range: "Self",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Next ranged attack deals 4d8 lightning damage instead of normal damage. Hit or miss, each creature within 10 feet of target makes Dex save or takes 2d8 lightning damage.",
      damage: "4d8",
      damageType: "lightning",
      saveType: "dexterity",
      classes: ["Ranger"],
      upcastDamage: "1d8"
    },
    {
      name: "Aura of Vitality",
      school: "Evocation",
      castTime: "1 action",
      range: "Self (30-foot radius)",
      components: "V",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Healing energy radiates from you. As a bonus action, cause one creature in aura to regain 2d6 hit points.",
      healing: "2d6",
      classes: ["Paladin"]
    },
    {
      name: "Crusader's Mantle",
      school: "Evocation",
      castTime: "1 action",
      range: "Self",
      components: "V",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Holy power radiates in 30-foot aura. Nonhostile creatures in aura deal an extra 1d4 radiant damage when they hit with weapon attacks.",
      damage: "1d4",
      damageType: "radiant",
      classes: ["Paladin"]
    },
    {
      name: "Elemental Weapon",
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Nonmagical weapon becomes +1 weapon dealing extra 1d4 damage of chosen type: acid, cold, fire, lightning, or thunder.",
      damage: "1d4",
      damageType: "varies",
      classes: ["Paladin"],
      upcastEffect: "+2 and 2d4 at 5th-6th, +3 and 3d4 at 7th+."
    },
    {
      name: "Fear",
      school: "Illusion",
      castTime: "1 action",
      range: "Self (30-foot cone)",
      components: "V, S, M",
      componentDetails: { material: "a white feather or the heart of a hen" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Creatures in 30-foot cone must make Wisdom save or drop held items and become frightened. Must Dash away from you.",
      saveType: "wisdom",
      spellType: "control",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Hunger of Hadar",
      school: "Conjuration",
      castTime: "1 action",
      range: "150 feet",
      components: "V, S, M",
      componentDetails: { material: "a pickled octopus tentacle" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "20-foot-radius sphere of blackness and bitter cold. Creatures starting turn inside take 2d6 cold damage. Creatures ending turn inside take 2d6 acid damage.",
      damage: "2d6",
      damage2: "2d6",
      damageType: "cold",
      damageType2: "acid",
      saveType: "dexterity",
      classes: ["Warlock"]
    },
    {
      name: "Hypnotic Pattern",
      school: "Illusion",
      castTime: "1 action",
      range: "120 feet",
      components: "S, M",
      componentDetails: { material: "a glowing stick of incense or a crystal vial filled with phosphorescent material" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "30-foot cube of twisting patterns. Creatures must make Wisdom save or become charmed and incapacitated. Speed 0.",
      saveType: "wisdom",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Major Image",
      school: "Illusion",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      componentDetails: { material: "a bit of fleece" },
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Create image of object, creature, or phenomenon no larger than 20-foot cube. Includes sound, smell, and temperature.",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
      upcastEffect: "At 6th level or higher, spell lasts until dispelled"
    },
    {
      name: "Mass Healing Word",
      school: "Evocation",
      castTime: "1 bonus action",
      range: "60 feet",
      components: "V",
      duration: "Instantaneous",
      description: "Up to 6 creatures regain HP equal to 1d4 + spellcasting modifier.",
      healing: "1d4",
      spellType: "healing",
      classes: ["Cleric"],
      upcastEffect: "1d4 additional healing per slot level above 3rd"
    },
    {
      name: "Spirit Guardians",
      school: "Conjuration",
      castTime: "1 action",
      range: "Self (15-foot radius)",
      components: "V, S, M",
      componentDetails: { material: "a holy symbol" },
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Spirits protect you in 15-foot radius. Creatures entering area or starting turn there make Wisdom save or take 3d8 radiant/necrotic damage (half on save). Speed halved in area.",
      damage: "3d8",
      damageType: "radiant",
      saveType: "wisdom",
      classes: ["Cleric"],
      upcastDamage: "1d8"
    },
    {
      name: "Tongues",
      school: "Divination",
      castTime: "1 action",
      range: "Touch",
      components: "V, M",
      componentDetails: { material: "a small clay model of a ziggurat" },
      duration: "1 hour",
      description: "Creature touched gains ability to understand any spoken language and speak so any creature that knows a language understands it.",
      classes: ["Bard", "Cleric", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Vampiric Touch",
      school: "Necromancy",
      castTime: "1 action",
      range: "Self",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Melee spell attack deals 3d6 necrotic damage and you regain HP equal to half damage dealt. Can repeat each turn.",
      damage: "3d6",
      damageType: "necrotic",
      saveType: "attack",
      classes: ["Warlock", "Wizard"],
      upcastDamage: "1d6"
    },
    // [2025-11-25] Phase 2: Additional 3rd level spells from PHB audit
    {
      name: "Animate Dead",
      school: "Necromancy",
      castTime: "1 minute",
      range: "10 feet",
      components: "V, S, M",
      componentDetails: { material: "a drop of blood, a piece of flesh, and a pinch of bone dust" },
      duration: "Instantaneous",
      description: "Create an undead servant from a pile of bones or a corpse. It obeys your commands.",
      classes: ["Cleric", "Wizard"],
      upcastEffect: "Animate or reassert control over 2 additional undead per slot level above 3rd"
    },
    {
      name: "Beacon of Hope",
      school: "Abjuration",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Creatures have advantage on Wisdom saves and death saves, and regain maximum HP from healing.",
      classes: ["Cleric"]
    },
    {
      name: "Bestow Curse",
      school: "Necromancy",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Touch a creature. Wisdom save or cursed: disadvantage on ability checks/attacks, or lose action, or take extra 1d8 necrotic on your attacks.",
      saveType: "wisdom",
      spellType: "debuff",
      classes: ["Bard", "Cleric", "Wizard"],
      upcastEffect: "At 4th: 10 min duration. At 5th: 8 hours. At 7th: 24 hours. At 9th: permanent"
    },
    {
      name: "Clairvoyance",
      school: "Divination",
      castTime: "10 minutes",
      range: "1 mile",
      components: "V, S, M",
      componentDetails: { material: "a focus worth at least 100 gp (crystal ball, silver mirror, or holy water font)" },
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Create an invisible sensor within range. You can see or hear (choose one) through the sensor.",
      classes: ["Bard", "Cleric", "Sorcerer", "Wizard"]
    },
    {
      name: "Conjure Animals",
      school: "Conjuration",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Summon fey spirits that take animal forms. CR depends on spell slot level.",
      classes: ["Druid", "Ranger"],
      upcastEffect: "Higher slots summon more/stronger creatures"
    },
    {
      name: "Create Food and Water",
      school: "Conjuration",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Create 45 pounds of food and 30 gallons of water, enough for 15 humanoids or 5 steeds for 24 hours.",
      classes: ["Cleric", "Paladin"]
    },
    {
      name: "Daylight",
      school: "Evocation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "1 hour",
      description: "60-foot-radius sphere of bright light, dim light for additional 60 feet. Dispels darkness created by spells of 3rd level or lower.",
      classes: ["Cleric", "Druid", "Paladin", "Ranger", "Sorcerer"]
    },
    {
      name: "Feign Death",
      school: "Necromancy",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a pinch of graveyard dirt" },
      duration: "1 hour",
      ritual: true,
      description: "Willing creature appears dead. Blinded, incapacitated, speed 0, resistant to all damage except psychic.",
      classes: ["Bard", "Cleric", "Druid", "Wizard"]
    },
    {
      name: "Gaseous Form",
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a bit of gauze and a wisp of smoke" },
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Transform willing creature into misty cloud. Flying speed 10, resistance to nonmagical damage, advantage on Str/Dex/Con saves.",
      classes: ["Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Glyph of Warding",
      school: "Abjuration",
      castTime: "1 hour",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "incense and powdered diamond worth at least 200 gp, which the spell consumes", consumed: true, cost: 200 },
      duration: "Until dispelled or triggered",
      description: "Inscribe a glyph that triggers when conditions met. Explosive (5d8 damage) or store a spell up to 3rd level.",
      classes: ["Bard", "Cleric", "Wizard"],
      upcastEffect: "Explosive damage +1d8 per slot level above 3rd; stored spell can match slot level"
    },
    {
      name: "Magic Circle",
      school: "Abjuration",
      castTime: "1 minute",
      range: "10 feet",
      components: "V, S, M",
      componentDetails: { material: "holy water or powdered silver and iron worth at least 100 gp, which the spell consumes", consumed: true, cost: 100 },
      duration: "1 hour",
      description: "10-foot radius cylinder protects against celestials, elementals, fey, fiends, or undead. Chosen type can't enter, has disadvantage on attacks.",
      classes: ["Cleric", "Paladin", "Warlock", "Wizard"],
      upcastEffect: "Duration +1 hour per slot level above 3rd"
    },
    {
      name: "Meld into Stone",
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "8 hours",
      ritual: true,
      description: "Step into stone object large enough to contain you. You can cast spells on yourself while inside.",
      classes: ["Cleric", "Druid"]
    },
    {
      name: "Nondetection",
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a pinch of diamond dust worth 25 gp sprinkled over the target, which the spell consumes", consumed: true, cost: 25 },
      duration: "8 hours",
      description: "Target hidden from divination magic. Can't be targeted by divination or perceived through magical scrying sensors.",
      classes: ["Bard", "Ranger", "Wizard"]
    },
    {
      name: "Plant Growth",
      school: "Transmutation",
      castTime: "1 action or 8 hours",
      range: "150 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Rapid growth (100-foot radius, 4 feet of movement costs 1 extra foot) or enriched land (half-mile radius, double yield for 1 year).",
      classes: ["Bard", "Druid", "Ranger"]
    },
    {
      name: "Protection from Energy",
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Creature has resistance to acid, cold, fire, lightning, or thunder damage (choose one) for the duration.",
      spellType: "buff",
      classes: ["Cleric", "Druid", "Ranger", "Sorcerer", "Wizard"]
    },
    {
      name: "Remove Curse",
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "Instantaneous",
      description: "All curses affecting one creature or object end. If cursed magic item, curse remains but attunement breaks.",
      classes: ["Cleric", "Paladin", "Warlock", "Wizard"]
    },
    {
      name: "Sending",
      school: "Evocation",
      castTime: "1 action",
      range: "Unlimited",
      components: "V, S, M",
      componentDetails: { material: "a short piece of fine copper wire" },
      duration: "1 round",
      description: "Send 25-word message to creature familiar to you. It hears the message in its mind and can reply immediately with 25 words.",
      classes: ["Bard", "Cleric", "Wizard"]
    },
    {
      name: "Sleet Storm",
      school: "Conjuration",
      castTime: "1 action",
      range: "150 feet",
      components: "V, S, M",
      componentDetails: { material: "a pinch of dust and a few drops of water" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "40-foot-radius, 20-foot-high cylinder. Heavily obscured, difficult terrain. Dex save or fall prone. Concentration checks at disadvantage.",
      classes: ["Druid", "Sorcerer", "Wizard"]
    },
    {
      name: "Speak with Dead",
      school: "Necromancy",
      castTime: "1 action",
      range: "10 feet",
      components: "V, S, M",
      componentDetails: { material: "burning incense" },
      duration: "10 minutes",
      description: "Corpse answers up to 5 questions. Answers are brief, cryptic, or repetitive. Can't learn new information or speculate.",
      classes: ["Bard", "Cleric"]
    },
    {
      name: "Speak with Plants",
      school: "Transmutation",
      castTime: "1 action",
      range: "Self (30-foot radius)",
      components: "V, S",
      duration: "10 minutes",
      description: "Communicate with plants. Plants can perform simple tasks. Difficult terrain from plants costs no extra movement for you.",
      classes: ["Bard", "Druid", "Ranger"]
    },
    {
      name: "Stinking Cloud",
      school: "Conjuration",
      castTime: "1 action",
      range: "90 feet",
      components: "V, S, M",
      componentDetails: { material: "a rotten egg or several skunk cabbage leaves" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "20-foot-radius sphere of noxious gas. Con save or spend action retching. Lightly obscured.",
      saveType: "constitution",
      classes: ["Bard", "Sorcerer", "Wizard"]
    },
    {
      name: "Water Breathing",
      school: "Transmutation",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "a short reed or piece of straw" },
      duration: "24 hours",
      ritual: true,
      description: "Up to 10 creatures can breathe underwater for the duration.",
      classes: ["Druid", "Ranger", "Sorcerer", "Wizard"]
    },
    {
      name: "Water Walk",
      school: "Transmutation",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "a piece of cork" },
      duration: "1 hour",
      ritual: true,
      description: "Up to 10 willing creatures can walk on liquid surfaces as if solid ground.",
      classes: ["Cleric", "Druid", "Ranger", "Sorcerer"]
    },
    {
      name: "Wind Wall",
      school: "Evocation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      componentDetails: { material: "a tiny fan and a feather of exotic origin" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Wall of strong wind up to 50 feet long, 15 feet high, 1 foot thick. 3d8 bludgeoning to creatures, disperses gas/fog, deflects ranged attacks.",
      damage: "3d8",
      damageType: "bludgeoning",
      saveType: "strength",
      classes: ["Druid", "Ranger"]
    }
  ],
  4: [ // Level 4  
    {
      name: "Banishment",
      level: 4,
      school: "Abjuration",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Target must succeed on a Charisma save or be banished to another plane.",
      saveType: "charisma",
      spellType: "control",
      concentration: true,
      classes: ["Cleric", "Paladin", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Blight",
      level: 4,
      school: "Necromancy",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Target takes 8d8 necrotic damage on failed Con save.",
      damage: "8d8",
      damageType: "necrotic",
      saveType: "constitution",
      classes: ["Druid", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Confusion",
      level: 4,
      school: "Enchantment",
      castTime: "1 action",
      range: "90 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Creatures in 10-foot radius must succeed on Wisdom save or become confused.",
      saveType: "wisdom",
      spellType: "control",
      concentration: true,
      classes: ["Bard", "Druid", "Sorcerer", "Wizard"]
    },
    {
      name: "Dimension Door",
      level: 4,
      school: "Conjuration",
      castTime: "1 action",
      range: "500 feet",
      components: "V",
      duration: "Instantaneous",
      description: "Teleport yourself and one willing creature to a destination you can see or describe.",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Greater Invisibility",
      level: 4,
      school: "Illusion",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      description: "Creature becomes invisible for duration, doesn't end when attacking.",
      concentration: true,
      classes: ["Bard", "Sorcerer", "Wizard"]
    },
    {
      name: "Ice Storm",
      level: 4,
      school: "Evocation",
      castTime: "1 action",
      range: "300 feet",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "20-foot radius, 2d8 bludgeoning + 4d6 cold damage.",
      damage: "2d8+4d6",
      damageType: "bludgeoning/cold",
      saveType: "dexterity",
      classes: ["Druid", "Sorcerer", "Wizard"]
    },
    {
      name: "Polymorph",
      level: 4,
      school: "Transmutation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 hour",
      description: "Transform creature into beast with CR equal or less than target's level.",
      saveType: "wisdom",
      concentration: true,
      classes: ["Bard", "Druid", "Sorcerer", "Wizard"]
    },
    {
      name: "Wall of Fire",
      level: 4,
      school: "Evocation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Create wall dealing 5d8 fire damage to creatures within 10 feet.",
      damage: "5d8",
      damageType: "fire",
      saveType: "dexterity",
      concentration: true,
      classes: ["Druid", "Sorcerer", "Wizard"]
    },
    // [2025-11-25] Added missing 4th level spells from PHB audit
    {
      name: "Staggering Smite",
      level: 4,
      school: "Evocation",
      castTime: "1 bonus action",
      range: "Self",
      components: "V",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Next weapon hit deals extra 4d6 psychic damage. Target makes Wisdom save or has disadvantage on attacks/ability checks, can't take reactions, until end of its next turn.",
      damage: "4d6",
      damageType: "psychic",
      saveType: "wisdom",
      classes: ["Paladin"]
    },
    // [2025-11-25] Missing PHB 4th level Paladin Aura spells
    {
      name: "Aura of Life",
      level: 4,
      school: "Abjuration",
      castTime: "1 action",
      range: "Self (30-foot radius)",
      components: "V",
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Life-preserving aura in 30-foot radius. Nonhostile creatures have resistance to necrotic damage. At 0 HP, nonhostile creatures regain 1 HP at start of their turn if not incapacitated.",
      classes: ["Paladin"]
    },
    {
      name: "Aura of Purity",
      level: 4,
      school: "Abjuration",
      castTime: "1 action",
      range: "Self (30-foot radius)",
      components: "V",
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Purifying aura in 30-foot radius. Nonhostile creatures can't become diseased, have resistance to poison damage, and advantage on saves against blinded, charmed, deafened, frightened, paralyzed, poisoned, stunned.",
      classes: ["Paladin"]
    },
    {
      name: "Find Greater Steed",
      level: 4,
      school: "Conjuration",
      castTime: "10 minutes",
      range: "30 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Summon a spirit that takes the form of a loyal mount: griffon, pegasus, peryton, dire wolf, rhinoceros, or saber-toothed tiger. Telepathic bond, can share spells that target only you.",
      classes: ["Paladin"]
    },
    {
      name: "Freedom of Movement",
      level: 4,
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a leather strap, bound around the arm or a similar appendage" },
      duration: "1 hour",
      description: "Target's movement is unaffected by difficult terrain, and spells/effects can't reduce speed or cause paralyzed/restrained. Can spend 5 feet to escape nonmagical restraints.",
      classes: ["Bard", "Cleric", "Druid", "Paladin", "Ranger"]
    },
    {
      name: "Locate Creature",
      level: 4,
      school: "Divination",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "a bit of fur from a bloodhound" },
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Describe or name a creature familiar to you. Learn direction to creature if within 1,000 feet. Blocked by running water.",
      classes: ["Bard", "Cleric", "Druid", "Paladin", "Ranger", "Wizard"]
    },
    // [2025-11-25] Phase 3 - Missing 4th level spells from comprehensive PHB audit
    {
      name: "Arcane Eye",
      level: 4,
      school: "Divination",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "a bit of bat fur" },
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Create invisible magical eye within range. You mentally receive visual information from it. Can look in any direction. Can move eye up to 30 feet as an action. No limit to range, but can't pass through solid barriers.",
      classes: ["Wizard"]
    },
    {
      name: "Compulsion",
      level: 4,
      school: "Enchantment",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Creatures you choose in range must make Wisdom save or be charmed. While charmed, use bonus action to designate direction - target uses as much movement as possible in that direction.",
      saveType: "wisdom",
      classes: ["Bard"]
    },
    {
      name: "Conjure Minor Elementals",
      level: 4,
      school: "Conjuration",
      castTime: "1 minute",
      range: "90 feet",
      components: "V, S",
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Summon elementals of CR 2 or lower (one CR 2, two CR 1, four CR 1/2, or eight CR 1/4). Obey verbal commands, act on your initiative. Disappear when reduced to 0 HP or spell ends.",
      classes: ["Druid", "Wizard"],
      upcastEffect: "Summon twice as many at 6th, three times at 8th."
    },
    {
      name: "Conjure Woodland Beings",
      level: 4,
      school: "Conjuration",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      componentDetails: { material: "one holly berry per creature summoned" },
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Summon fey creatures of CR 2 or lower (one CR 2, two CR 1, four CR 1/2, or eight CR 1/4). Obey verbal commands, act on your initiative. Disappear when reduced to 0 HP or spell ends.",
      classes: ["Druid", "Ranger"],
      upcastEffect: "Summon twice as many at 6th, three times at 8th."
    },
    {
      name: "Control Water",
      level: 4,
      school: "Transmutation",
      castTime: "1 action",
      range: "300 feet",
      components: "V, S, M",
      componentDetails: { material: "a drop of water and a pinch of dust" },
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Control freestanding water in 100-foot cube. Choose effect: Flood (raise water up to 20 feet), Part Water (trench through area), Redirect Flow (cause flowing water to move in chosen direction), or Whirlpool (5d8 bludgeoning, restrained on failed Str save).",
      damage: "5d8",
      damageType: "bludgeoning",
      saveType: "strength",
      classes: ["Cleric", "Druid", "Wizard"]
    },
    {
      name: "Death Ward",
      level: 4,
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "8 hours",
      description: "First time target would drop to 0 HP, drops to 1 HP instead. Also protects against instant-death effects. Spell ends after protecting once.",
      classes: ["Cleric", "Paladin"]
    },
    {
      name: "Divination",
      level: 4,
      school: "Divination",
      ritual: true,
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "incense and a sacrificial offering appropriate to your religion, together worth at least 25 gp, which the spell consumes", consumed: true, cost: 25 },
      duration: "Instantaneous",
      description: "Contact your deity or divine proxy for guidance about a specific goal, event, or activity within 7 days. DM offers a truthful reply - short phrase, cryptic rhyme, or omen.",
      classes: ["Cleric"]
    },
    {
      name: "Dominate Beast",
      level: 4,
      school: "Enchantment",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Beast must succeed on Wisdom save or be charmed and telepathically controlled. Takes damage = new save. Direct control uses your action; otherwise follows last command.",
      saveType: "wisdom",
      classes: ["Druid", "Sorcerer"],
      upcastEffect: "Duration: 10 min at 5th, 1 hour at 6th, 8 hours at 7th."
    },
    {
      name: "Evard's Black Tentacles",
      level: 4,
      school: "Conjuration",
      castTime: "1 action",
      range: "90 feet",
      components: "V, S, M",
      componentDetails: { material: "a piece of tentacle from a giant octopus or a giant squid" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "20-foot square becomes difficult terrain. Creatures entering or starting turn there make Dex save or take 3d6 bludgeoning and are restrained. Restrained creature takes 3d6 at start of each turn.",
      damage: "3d6",
      damageType: "bludgeoning",
      saveType: "dexterity",
      classes: ["Wizard"]
    },
    {
      name: "Fabricate",
      level: 4,
      school: "Transmutation",
      castTime: "10 minutes",
      range: "120 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Convert raw materials into products of the same material: 10-foot cube of nonmagical material, or a single object up to 5-foot cube. Must have proficiency with artisan's tools for complex items.",
      classes: ["Wizard"]
    },
    {
      name: "Fire Shield",
      level: 4,
      school: "Evocation",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "a bit of phosphorus or a firefly" },
      duration: "10 minutes",
      description: "Flames surround you, shedding light. Choose warm (fire resistance, 2d8 fire damage to melee attackers) or chill (cold resistance, 2d8 cold damage to melee attackers).",
      damage: "2d8",
      damageType: "fire",
      spellType: "buff",
      classes: ["Wizard"]
    },
    {
      name: "Giant Insect",
      level: 4,
      school: "Transmutation",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S",
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Transform up to 10 centipedes, 3 spiders, 5 wasps, or 1 scorpion into giant versions. Obey verbal commands. Revert if reduced to 0 HP or spell ends.",
      classes: ["Druid"]
    },
    {
      name: "Grasping Vine",
      level: 4,
      school: "Conjuration",
      castTime: "1 bonus action",
      range: "30 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Conjure vine on solid surface. As bonus action, direct vine to lash out at creature within 30 feet - Dex save or pulled 20 feet toward vine.",
      saveType: "dexterity",
      classes: ["Druid", "Ranger"]
    },
    {
      name: "Guardian of Faith",
      level: 4,
      school: "Conjuration",
      castTime: "1 action",
      range: "30 feet",
      components: "V",
      duration: "8 hours",
      description: "Spectral guardian appears in unoccupied 5-foot space. Hostile creature within 10 feet for first time on turn must make Dex save or take 20 radiant damage (half on save). Guardian disappears after dealing 60 total damage.",
      damage: "20",
      damageType: "radiant",
      saveType: "dexterity",
      classes: ["Cleric"]
    },
    {
      name: "Hallucinatory Terrain",
      level: 4,
      school: "Illusion",
      castTime: "10 minutes",
      range: "300 feet",
      components: "V, S, M",
      componentDetails: { material: "a stone, a twig, and a bit of green plant" },
      duration: "24 hours",
      description: "Make terrain in 150-foot cube look, sound, and smell like another natural terrain. Creatures can use action to make Investigation check against spell DC to disbelieve.",
      classes: ["Bard", "Druid", "Warlock", "Wizard"]
    },
    {
      name: "Leomund's Secret Chest",
      level: 4,
      school: "Conjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "an exquisite chest, 3 feet by 2 feet by 2 feet, and its tiny replica, together worth at least 5,050 gp", cost: 5050 },
      duration: "Instantaneous",
      description: "Hide chest on Ethereal Plane. Use action to recall or send away chest. After 60 days, 5% cumulative chance per day that spell ends and chest lost on Ethereal Plane.",
      classes: ["Wizard"]
    },
    {
      name: "Mordenkainen's Faithful Hound",
      level: 4,
      school: "Conjuration",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "a tiny silver whistle, a piece of bone, and a thread" },
      duration: "8 hours",
      description: "Conjure phantom watchdog. Barks if Small or larger creature comes within 30 feet. On your turn, can bite creature within 5 feet: +5 to hit, 4d8 piercing damage. Can see invisible creatures.",
      damage: "4d8",
      damageType: "piercing",
      classes: ["Wizard"]
    },
    {
      name: "Mordenkainen's Private Sanctum",
      level: 4,
      school: "Abjuration",
      castTime: "10 minutes",
      range: "120 feet",
      components: "V, S, M",
      componentDetails: { material: "a thin sheet of lead, a piece of opaque glass, a wad of cotton or cloth, and powdered chrysolite" },
      duration: "24 hours",
      description: "Create 100-foot cube with these effects: sound can't pass, area is darkened from outside, divination spells can't target area or contents, creatures can't teleport in, planar travel blocked.",
      classes: ["Wizard"],
      upcastEffect: "+100-foot cube per level above 4th. Casting for 1 year makes permanent."
    },
    {
      name: "Otiluke's Resilient Sphere",
      level: 4,
      school: "Evocation",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "a hemispherical piece of clear crystal and a matching hemispherical piece of gum arabic" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Large or smaller creature makes Dex save or is enclosed in shimmering force sphere. Nothing can pass through, but creature can breathe. Immune to all damage. Can roll the sphere at half speed.",
      saveType: "dexterity",
      classes: ["Wizard"]
    },
    {
      name: "Phantasmal Killer",
      level: 4,
      school: "Illusion",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Target makes Wisdom save or becomes frightened. At end of each turn, must make Wisdom save or take 4d10 psychic damage. Success ends spell.",
      damage: "4d10",
      damageType: "psychic",
      saveType: "wisdom",
      classes: ["Wizard"],
      upcastDamage: "1d10"
    },
    {
      name: "Stone Shape",
      level: 4,
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "soft clay, which must be worked into roughly the desired shape of the stone object" },
      duration: "Instantaneous",
      description: "Touch stone object Medium or smaller, or 5-foot section of larger stone. Form it into any shape that suits your purpose. Can include rough hinges, latches, etc.",
      classes: ["Cleric", "Druid", "Wizard"]
    },
    {
      name: "Stoneskin",
      level: 4,
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "diamond dust worth 100 gp, which the spell consumes", consumed: true, cost: 100 },
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Target gains resistance to nonmagical bludgeoning, piercing, and slashing damage.",
      spellType: "buff",
      classes: ["Druid", "Ranger", "Sorcerer", "Wizard"]
    }
  ],
  5: [ // Level 5
    {
      name: "Cloudkill",
      level: 5,
      school: "Conjuration",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Concentration, up to 10 minutes",
      description: "20-foot radius sphere of poison, 5d8 poison damage on failed Con save.",
      damage: "5d8",
      damageType: "poison",
      saveType: "constitution",
      concentration: true,
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Cone of Cold",
      level: 5,
      school: "Evocation",
      castTime: "1 action",
      range: "Self (60-foot cone)",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "60-foot cone, 8d8 cold damage.",
      damage: "8d8",
      damageType: "cold",
      saveType: "constitution",
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Dominate Person",
      level: 5,
      school: "Enchantment",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      description: "Humanoid must succeed on Wisdom save or be charmed and controlled.",
      saveType: "wisdom",
      concentration: true,
      classes: ["Bard", "Sorcerer", "Wizard"]
    },
    {
      name: "Greater Restoration",
      level: 5,
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "End one effect reducing ability score, HP max, or levels of exhaustion.",
      classes: ["Bard", "Cleric", "Druid"]
    },
    {
      name: "Hold Monster",
      level: 5,
      school: "Enchantment",
      castTime: "1 action",
      range: "90 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Target must succeed on Wisdom save or be paralyzed.",
      saveType: "wisdom",
      spellType: "control",
      concentration: true,
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Mass Cure Wounds",
      level: 5,
      school: "Evocation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Up to 6 creatures regain 3d8 + modifier HP.",
      healing: "3d8",
      spellType: "healing",
      classes: ["Bard", "Cleric", "Druid"]
    },
    {
      name: "Teleportation Circle",
      level: 5,
      school: "Conjuration",
      castTime: "1 minute",
      range: "10 feet",
      components: "V, M",
      duration: "1 round",
      description: "Create a circle that teleports creatures to a permanent circle you know.",
      classes: ["Bard", "Sorcerer", "Wizard"]
    },
    {
      name: "Wall of Stone",
      level: 5,
      school: "Evocation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      duration: "Concentration, up to 10 minutes",
      description: "Create a wall of solid stone that can be shaped.",
      concentration: true,
      classes: ["Druid", "Sorcerer", "Wizard"]
    },
    // [2025-11-25] Added missing 5th level spells from PHB audit
    {
      name: "Banishing Smite",
      level: 5,
      school: "Abjuration",
      castTime: "1 bonus action",
      range: "Self",
      components: "V",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Next weapon hit deals extra 5d10 force damage. If target is reduced to 50 HP or less, it is banished. If native to different plane, banished permanently; otherwise returns after 1 minute.",
      damage: "5d10",
      damageType: "force",
      classes: ["Paladin"]
    },
    {
      name: "Raise Dead",
      level: 5,
      school: "Necromancy",
      castTime: "1 hour",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a diamond worth at least 500 gp, which the spell consumes", consumed: true, cost: 500 },
      duration: "Instantaneous",
      description: "Return a dead creature to life with 1 HP if it died within the last 10 days and isn't undead. -4 penalty to attacks/saves/checks, reduced by 1 each long rest.",
      classes: ["Bard", "Cleric", "Paladin"]
    },
    {
      name: "Scrying",
      level: 5,
      school: "Divination",
      castTime: "10 minutes",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "a focus worth at least 1,000 gp (crystal ball, silver mirror, or font)" },
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "See and hear a creature on the same plane. Target makes Wisdom save (modified by your knowledge and connection to target). On failure, you can see through invisible sensor.",
      saveType: "wisdom",
      classes: ["Bard", "Cleric", "Druid", "Warlock", "Wizard"]
    },
    // [2025-11-25] Phase 3 - Missing 5th level spells from comprehensive PHB audit
    {
      name: "Animate Objects",
      level: 5,
      school: "Transmutation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Animate up to 10 nonmagical objects. As bonus action, command them to move up to 30 feet and attack. Stats vary by size (Tiny: +8, 1d4+4; Small: +6, 1d8+2; Medium: +5, 2d6+1; Large: +6, 2d10+2; Huge: +8, 2d12+4).",
      classes: ["Bard", "Sorcerer", "Wizard"],
      upcastEffect: "+2 objects per level above 5th."
    },
    {
      name: "Antilife Shell",
      level: 5,
      school: "Abjuration",
      castTime: "1 action",
      range: "Self (10-foot radius)",
      components: "V, S",
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Barrier prevents creatures other than undead and constructs from passing or reaching through. Affected creatures can cast spells and make ranged attacks through it.",
      classes: ["Druid"]
    },
    {
      name: "Awaken",
      level: 5,
      school: "Transmutation",
      castTime: "8 hours",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "an agate worth at least 1,000 gp, which the spell consumes", consumed: true, cost: 1000 },
      duration: "Instantaneous",
      description: "Grant beast or plant an Intelligence of 10, ability to speak one language you know, and ability to move. Charmed by you for 30 days or until you harm it.",
      classes: ["Bard", "Druid"]
    },
    {
      name: "Bigby's Hand",
      level: 5,
      school: "Evocation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      componentDetails: { material: "an eggshell and a snakeskin glove" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Create Large hand of force. Use bonus action to move 60 feet and use one effect: Clenched Fist (4d8 force, Str check or push), Forceful Hand (push + Str check), Grasping Hand (grapple + 2d6+modifier crushing), Interposing Hand (half cover, can't move through).",
      damage: "4d8",
      damageType: "force",
      classes: ["Wizard"],
      upcastDamage: "2d8"
    },
    {
      name: "Circle of Power",
      level: 5,
      school: "Abjuration",
      castTime: "1 action",
      range: "Self (30-foot radius)",
      components: "V",
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Allies within 30 feet have advantage on saves against spells and magical effects. On successful save against spell that deals half damage, take no damage instead.",
      classes: ["Paladin"]
    },
    {
      name: "Commune",
      level: 5,
      school: "Divination",
      ritual: true,
      castTime: "1 minute",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "incense and a vial of holy or unholy water" },
      duration: "1 minute",
      description: "Contact your deity and ask up to 3 yes/no questions. Divine beings aren't omniscient, so may answer 'unclear'. Using more than once per long rest = 25% cumulative failure chance.",
      classes: ["Cleric"]
    },
    {
      name: "Commune with Nature",
      level: 5,
      school: "Divination",
      ritual: true,
      castTime: "1 minute",
      range: "Self",
      components: "V, S",
      duration: "Instantaneous",
      description: "Gain knowledge of surrounding 3-mile territory (or 300 feet underground). Learn up to 3 facts about: terrain, plants, animals, powerful creatures, buildings, or other aspects.",
      classes: ["Druid", "Ranger"]
    },
    {
      name: "Conjure Elemental",
      level: 5,
      school: "Conjuration",
      castTime: "1 minute",
      range: "90 feet",
      components: "V, S, M",
      componentDetails: { material: "burning incense (air), soft clay (earth), sulfur and phosphorus (fire), or water and sand (water)" },
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Summon elemental of CR 5 or lower that obeys verbal commands. If concentration broken, elemental becomes hostile and attacks nearest creatures.",
      classes: ["Druid", "Wizard"],
      upcastEffect: "+1 CR per level above 5th."
    },
    {
      name: "Conjure Volley",
      level: 5,
      school: "Conjuration",
      castTime: "1 action",
      range: "150 feet",
      components: "V, S, M",
      componentDetails: { material: "one piece of ammunition or one thrown weapon" },
      duration: "Instantaneous",
      description: "Fire ammunition or throw weapon, which multiplies into a volley. Each creature in 40-foot radius, 20-foot high cylinder makes Dex save or takes 8d8 damage of the weapon's type.",
      damage: "8d8",
      damageType: "piercing",
      saveType: "dexterity",
      classes: ["Ranger"]
    },
    {
      name: "Contact Other Plane",
      level: 5,
      school: "Divination",
      ritual: true,
      castTime: "1 minute",
      range: "Self",
      components: "V",
      duration: "1 minute",
      description: "Contact demigod, spirit of long-dead sage, or other mysterious entity. Make DC 15 Int save or take 6d6 psychic and be insane until long rest. On success, ask up to 5 questions with one-word answers.",
      damage: "6d6",
      damageType: "psychic",
      classes: ["Warlock", "Wizard"]
    },
    {
      name: "Contagion",
      level: 5,
      school: "Necromancy",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "7 days",
      description: "Melee spell attack inflicts disease. Target is poisoned. At end of each turn, Con save. After 3 failures, choose disease: Blinding Sickness, Filth Fever, Flesh Rot, Mindfire, Seizure, or Slimy Doom.",
      classes: ["Cleric", "Druid"]
    },
    {
      name: "Creation",
      level: 5,
      school: "Illusion",
      castTime: "1 minute",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "a tiny piece of matter of the same type of the item you plan to create" },
      duration: "Special",
      description: "Create nonliving object of vegetable matter (5-foot cube). Duration varies: vegetable 1 day, stone/crystal 12 hours, precious metals 1 hour, gems 10 minutes, adamantine/mithral 1 minute.",
      classes: ["Sorcerer", "Wizard"],
      upcastEffect: "+5-foot cube per level above 5th."
    },
    {
      name: "Destructive Wave",
      level: 5,
      school: "Evocation",
      castTime: "1 action",
      range: "Self (30-foot radius)",
      components: "V",
      duration: "Instantaneous",
      description: "Each creature you choose within 30 feet makes Con save or takes 5d6 thunder + 5d6 radiant/necrotic damage and is knocked prone. Half damage on success, not prone.",
      damage: "5d6",
      damageType: "thunder",
      damage2: "5d6",
      damageType2: "radiant",
      saveType: "constitution",
      classes: ["Paladin"]
    },
    {
      name: "Dispel Evil and Good",
      level: 5,
      school: "Abjuration",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "holy water or powdered silver and iron" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Celestials, elementals, fey, fiends, and undead have disadvantage on attacks against you. Can end spell to: break enchantment, or dismiss extraplanar creature (Cha save or sent back).",
      classes: ["Cleric", "Paladin"]
    },
    {
      name: "Dream",
      level: 5,
      school: "Illusion",
      castTime: "1 minute",
      range: "Special",
      components: "V, S, M",
      componentDetails: { material: "a handful of sand, a dab of ink, and a writing quill plucked from a sleeping bird" },
      duration: "8 hours",
      description: "Shape dreams of creature you know on same plane. Messenger can emerge as monstrous: target makes Wis save or gains no benefit from rest and takes 3d6 psychic damage on waking.",
      damage: "3d6",
      damageType: "psychic",
      saveType: "wisdom",
      classes: ["Bard", "Warlock", "Wizard"]
    },
    {
      name: "Flame Strike",
      level: 5,
      school: "Evocation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      componentDetails: { material: "pinch of sulfur" },
      duration: "Instantaneous",
      description: "10-foot radius, 40-foot high cylinder. Creatures make Dex save or take 4d6 fire + 4d6 radiant damage (half on save). Half fire damage, half radiant damage.",
      damage: "4d6",
      damageType: "fire",
      damage2: "4d6",
      damageType2: "radiant",
      saveType: "dexterity",
      classes: ["Cleric"],
      // [BATCH 9 / P1 D-19 — APR 2026]: PHB p.242 — "When you cast this
      //   spell using a spell slot of 6th level or higher, the damage
      //   increases by 1d6 for each slot level above 5th. You can deal
      //   half this extra damage as fire and half as radiant damage."
      //   Both streams scale: upcastDamage applies to the primary fire
      //   stream, upcastDamage2 to the secondary radiant stream. Pre-fix
      //   only upcastDamage existed so half the upcast damage was
      //   silently lost.
      upcastDamage: "1d6",
      upcastDamage2: "1d6"
    },
    {
      name: "Geas",
      level: 5,
      school: "Enchantment",
      castTime: "1 minute",
      range: "60 feet",
      components: "V",
      duration: "30 days",
      description: "Command creature to carry out service or refrain from action. 5d10 psychic damage per day if acts against command. Creature that can't understand you is unaffected.",
      damage: "5d10",
      damageType: "psychic",
      saveType: "wisdom",
      classes: ["Bard", "Cleric", "Druid", "Paladin", "Wizard"],
      upcastEffect: "Duration: 1 year at 7th, permanent at 9th."
    },
    {
      name: "Hallow",
      level: 5,
      school: "Evocation",
      castTime: "24 hours",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "herbs, oils, and incense worth at least 1,000 gp, which the spell consumes", consumed: true, cost: 1000 },
      duration: "Until dispelled",
      description: "Imbue area (up to 60-foot radius) with holy power. Choose creature types to be affected or immune. Choose extra effect: Courage, Darkness, Daylight, Energy Protection, Everlasting Rest, Extradimensional Interference, Fear, Silence, Tongues.",
      classes: ["Cleric"]
    },
    {
      name: "Insect Plague",
      level: 5,
      school: "Conjuration",
      castTime: "1 action",
      range: "300 feet",
      components: "V, S, M",
      componentDetails: { material: "a few grains of sugar, some kernels of grain, and a smear of fat" },
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "20-foot radius sphere of swarming locusts. Area is difficult terrain and lightly obscured. 4d10 piercing damage on failed Con save (half on success) when entering or starting turn.",
      damage: "4d10",
      damageType: "piercing",
      saveType: "constitution",
      classes: ["Cleric", "Druid", "Sorcerer"],
      upcastDamage: "1d10"
    },
    {
      name: "Legend Lore",
      level: 5,
      school: "Divination",
      castTime: "10 minutes",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "incense worth at least 250 gp and four ivory strips worth at least 50 gp each, which the spell consumes", consumed: true, cost: 450 },
      duration: "Instantaneous",
      description: "Learn significant lore about a person, place, or object. Information is accurate but might be cloaked in metaphor. More famous = more information; might only learn where to find more.",
      classes: ["Bard", "Cleric", "Wizard"]
    },
    {
      name: "Mislead",
      level: 5,
      school: "Illusion",
      castTime: "1 action",
      range: "Self",
      components: "S",
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Become invisible and create illusory double at your location. Use action to move double up to twice your speed, make it gesture, speak, and behave however you like. Can see and hear through it.",
      classes: ["Bard", "Wizard"]
    },
    {
      name: "Modify Memory",
      level: 5,
      school: "Enchantment",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Charm creature and reshape its memory of an event within last 24 hours (lasting no more than 10 minutes). Target must make Wis save. Can eliminate, modify, or add memory.",
      saveType: "wisdom",
      classes: ["Bard", "Wizard"],
      upcastEffect: "Memory age: 7 days at 6th, 30 days at 7th, 1 year at 8th, any time at 9th."
    },
    {
      name: "Passwall",
      level: 5,
      school: "Transmutation",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "a pinch of sesame seeds" },
      duration: "1 hour",
      description: "Create passage through wood, plaster, or stone (not metal). Opening is 5 feet wide, 8 feet tall, 20 feet deep. Dispelling closes passage, trapping creatures inside.",
      classes: ["Wizard"]
    },
    {
      name: "Planar Binding",
      level: 5,
      school: "Abjuration",
      castTime: "1 hour",
      range: "60 feet",
      components: "V, S, M",
      componentDetails: { material: "a jewel worth at least 1,000 gp, which the spell consumes", consumed: true, cost: 1000 },
      duration: "24 hours",
      description: "Bind celestial, elemental, fey, or fiend that failed Cha save. Must obey instructions to best of ability. Can set conditions that end service early.",
      saveType: "charisma",
      classes: ["Bard", "Cleric", "Druid", "Wizard"],
      upcastEffect: "Duration: 10 days at 6th, 30 days at 7th, 180 days at 8th, 1 year and 1 day at 9th."
    },
    {
      name: "Reincarnate",
      level: 5,
      school: "Transmutation",
      castTime: "1 hour",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "rare oils and unguents worth at least 1,000 gp, which the spell consumes", consumed: true, cost: 1000 },
      duration: "Instantaneous",
      description: "Return dead humanoid to life in new body (died within 10 days, not undead). DM rolls on table to determine new race. Soul must be willing and not prevented from returning.",
      classes: ["Druid"]
    },
    {
      name: "Seeming",
      level: 5,
      school: "Illusion",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S",
      duration: "8 hours",
      description: "Disguise any number of creatures within range, including making them appear as different creatures. Unwilling target can make Cha save to resist. Investigation check to see through.",
      saveType: "charisma",
      classes: ["Bard", "Sorcerer", "Wizard"]
    },
    {
      name: "Swift Quiver",
      level: 5,
      school: "Transmutation",
      castTime: "1 bonus action",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a quiver containing at least one piece of ammunition" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Transmute quiver so it produces endless supply of nonmagical ammunition. As bonus action, make two attacks with weapon that uses ammunition from quiver.",
      classes: ["Ranger"]
    },
    {
      name: "Telekinesis",
      level: 5,
      school: "Transmutation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Move creature (Str check contested) or object up to 1,000 lbs up to 30 feet in any direction. Can exert fine control to manipulate simple tools, open doors, etc.",
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Tree Stride",
      level: 5,
      school: "Conjuration",
      castTime: "1 action",
      range: "Self",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Enter a living tree and step out of another tree of same kind within 500 feet. Uses 5 feet of movement. Can use once per round for duration.",
      classes: ["Druid", "Ranger"]
    },
    {
      name: "Wall of Force",
      level: 5,
      school: "Evocation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      componentDetails: { material: "a pinch of powder made by crushing a clear gemstone" },
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Invisible wall of force (10 panels of 10x10 feet or hemispherical dome/globe up to 10-foot radius). Nothing can physically pass. Immune to all damage. Dispelled by disintegrate.",
      classes: ["Wizard"]
    }
  ],
  6: [ // Level 6
    {
      name: "Chain Lightning",
      level: 6,
      school: "Evocation",
      castTime: "1 action",
      range: "150 feet",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "10d8 lightning damage to target, then jumps to 3 more targets.",
      damage: "10d8",
      damageType: "lightning",
      saveType: "dexterity",
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Disintegrate",
      level: 6,
      school: "Transmutation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "Target takes 10d6+40 force damage, reduced to 0 HP turns to dust.",
      damage: "10d6+40",
      damageType: "force",
      saveType: "dexterity",
      classes: ["Sorcerer", "Wizard"],
      // [BATCH 9 / P1 D-19 — APR 2026]: PHB p.233 — "When you cast this
      //   spell using a spell slot of 7th level or higher, the damage
      //   increases by 3d6 for each slot level above 6th." Pre-fix this
      //   field was absent so calculateUpcastDamage fell back to the
      //   default "1 die per slot" behavior (only +1d6/slot, badly under-
      //   damaging the spell at 7th-9th).
      upcastDamage: "3d6"
    },
    {
      name: "Harm",
      level: 6,
      school: "Necromancy",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Target takes 14d6 necrotic damage.",
      damage: "14d6",
      damageType: "necrotic",
      saveType: "constitution",
      classes: ["Cleric"]
    },
    {
      name: "Heal",
      level: 6,
      school: "Evocation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Target regains 70 hit points.",
      healing: "70",
      spellType: "healing",
      classes: ["Cleric", "Druid"]
    },
    {
      name: "Mass Suggestion",
      level: 6,
      school: "Enchantment",
      castTime: "1 action",
      range: "60 feet",
      components: "V, M",
      duration: "24 hours",
      description: "Up to 12 creatures must make Wisdom save or follow your suggestion.",
      saveType: "wisdom",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "True Seeing",
      level: 6,
      school: "Divination",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "1 hour",
      description: "Target has truesight, sees secret doors, and into Ethereal Plane (120 feet).",
      classes: ["Bard", "Cleric", "Sorcerer", "Warlock", "Wizard"]
    },
    // [2025-11-25] Phase 3 - Missing 6th level spells from comprehensive PHB audit
    {
      name: "Arcane Gate",
      level: 6,
      school: "Conjuration",
      castTime: "1 action",
      range: "500 feet",
      components: "V, S",
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Create two linked portals within range. Each portal is 10-foot diameter opening. Creatures can pass through one and exit the other.",
      classes: ["Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Blade Barrier",
      level: 6,
      school: "Evocation",
      castTime: "1 action",
      range: "90 feet",
      components: "V, S",
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Create wall of whirling blades (100 feet long, 20 feet high, 5 feet thick, or ringed wall up to 60-foot diameter). 6d10 slashing on failed Dex save when passing through or starting turn in wall.",
      damage: "6d10",
      damageType: "slashing",
      saveType: "dexterity",
      classes: ["Cleric"]
    },
    {
      name: "Circle of Death",
      level: 6,
      school: "Necromancy",
      castTime: "1 action",
      range: "150 feet",
      components: "V, S, M",
      componentDetails: { material: "the powder of a crushed black pearl worth at least 500 gp", cost: 500 },
      duration: "Instantaneous",
      description: "60-foot radius sphere of negative energy. Creatures make Con save or take 8d6 necrotic damage (half on save).",
      damage: "8d6",
      damageType: "necrotic",
      saveType: "constitution",
      classes: ["Sorcerer", "Warlock", "Wizard"],
      upcastDamage: "2d6"
    },
    {
      name: "Conjure Fey",
      level: 6,
      school: "Conjuration",
      castTime: "1 minute",
      range: "90 feet",
      components: "V, S",
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Summon fey creature of CR 6 or lower that obeys verbal commands. If concentration broken, fey becomes hostile.",
      classes: ["Druid", "Warlock"],
      upcastEffect: "+1 CR per level above 6th."
    },
    {
      name: "Contingency",
      level: 6,
      school: "Evocation",
      castTime: "10 minutes",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "a statuette of yourself carved from ivory and decorated with gems worth at least 1,500 gp", cost: 1500 },
      duration: "10 days",
      description: "Cast a 5th-level or lower spell (1 action casting time, targets you) that activates when specified circumstance occurs. Only one contingency can be active at a time.",
      classes: ["Wizard"]
    },
    {
      name: "Create Undead",
      level: 6,
      school: "Necromancy",
      castTime: "1 minute",
      range: "10 feet",
      components: "V, S, M",
      componentDetails: { material: "one clay pot filled with grave dirt, one clay pot filled with brackish water, and one 150 gp black onyx stone for each corpse", cost: 150 },
      duration: "Instantaneous",
      description: "Create up to 3 ghouls from Medium/Small corpses. Obey verbal commands for 24 hours. Must recast to maintain control.",
      classes: ["Cleric", "Warlock", "Wizard"],
      upcastEffect: "At 7th: 4 ghouls or 2 ghasts/wights. At 8th: 5 ghouls/3 ghasts/wights/2 mummies. At 9th: 6 ghouls/4 ghasts/wights/3 mummies."
    },
    {
      name: "Drawmij's Instant Summons",
      level: 6,
      school: "Conjuration",
      ritual: true,
      castTime: "1 minute",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a sapphire worth 1,000 gp", cost: 1000 },
      duration: "Until dispelled",
      description: "Touch object weighing 10 lbs or less and inscribe name on sapphire. Crush sapphire to teleport object to your hand, or learn who has it if on another plane.",
      classes: ["Wizard"]
    },
    {
      name: "Eyebite",
      level: 6,
      school: "Necromancy",
      castTime: "1 action",
      range: "Self",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Each turn, use action to target one creature within 60 feet. Choose Asleep (unconscious), Panicked (frightened, moves away), or Sickened (disadvantage, can't attack). Wis save negates.",
      saveType: "wisdom",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Find the Path",
      level: 6,
      school: "Divination",
      castTime: "1 minute",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "a set of divinatory tools worth 100 gp and an object from the location you wish to find", cost: 100 },
      duration: "Concentration, up to 1 day",
      concentration: true,
      description: "Know the shortest path to a specific fixed location on the same plane. Know correct direction at every junction.",
      classes: ["Bard", "Cleric", "Druid"]
    },
    {
      name: "Flesh to Stone",
      level: 6,
      school: "Transmutation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      componentDetails: { material: "a pinch of lime, water, and earth" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Target makes Con save or is restrained as it begins turning to stone. Target makes 3 saves - 3 successes ends spell, 3 failures turns to stone permanently (reversible by greater restoration).",
      saveType: "constitution",
      classes: ["Warlock", "Wizard"]
    },
    {
      name: "Forbiddance",
      level: 6,
      school: "Abjuration",
      ritual: true,
      castTime: "10 minutes",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a sprinkling of holy water, rare incense, and powdered ruby worth at least 1,000 gp", cost: 1000 },
      duration: "1 day",
      description: "Protect area up to 40,000 square feet. Teleportation blocked. Chosen creature types take 5d10 radiant/necrotic when entering or starting turn in area.",
      damage: "5d10",
      damageType: "radiant",
      classes: ["Cleric"]
    },
    {
      name: "Globe of Invulnerability",
      level: 6,
      school: "Abjuration",
      castTime: "1 action",
      range: "Self (10-foot radius)",
      components: "V, S, M",
      componentDetails: { material: "a glass or crystal bead that shatters when the spell ends" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Immobile 10-foot radius sphere. Spells of 5th level or lower cast from outside can't affect creatures or objects within. Sphere moves with you.",
      classes: ["Sorcerer", "Wizard"],
      upcastEffect: "+1 level of spell blocked per level above 6th."
    },
    {
      name: "Guards and Wards",
      level: 6,
      school: "Abjuration",
      castTime: "10 minutes",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "burning incense, a small measure of brimstone and oil, a knotted string, a small amount of umber hulk blood, and a small silver rod worth at least 10 gp", cost: 10 },
      duration: "24 hours",
      description: "Create wards protecting area up to 2,500 square feet. Effects include: corridors filled with fog, magic mouths, doors locked by arcane lock, and stairs/hallways filled with webs.",
      classes: ["Bard", "Wizard"]
    },
    {
      name: "Heroes' Feast",
      level: 6,
      school: "Conjuration",
      castTime: "10 minutes",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "a gem-encrusted bowl worth at least 1,000 gp, which the spell consumes", consumed: true, cost: 1000 },
      duration: "Instantaneous",
      description: "Create magnificent feast for up to 12 creatures. Eating takes 1 hour. Cures diseases/poison, grants immunity to poison/frightened, advantage on Wis saves, and 2d10 temporary HP. Lasts 24 hours.",
      classes: ["Cleric", "Druid"]
    },
    {
      name: "Magic Jar",
      level: 6,
      school: "Necromancy",
      castTime: "1 minute",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "a gem, crystal, reliquary, or some other ornamental container worth at least 500 gp", cost: 500 },
      duration: "Until dispelled",
      description: "Project soul into container. From there, can attempt to possess a humanoid within 100 feet (Cha save negates). Your body is catatonic during possession.",
      saveType: "charisma",
      classes: ["Wizard"]
    },
    {
      name: "Move Earth",
      level: 6,
      school: "Transmutation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      componentDetails: { material: "an iron blade and a small bag containing a mixture of soils" },
      duration: "Concentration, up to 2 hours",
      concentration: true,
      description: "Reshape terrain in 40-foot square. Move dirt, sand, and clay (not rock). Changes take 10 minutes per 40-foot square. Can raise/lower elevation, dig trenches, etc.",
      classes: ["Druid", "Sorcerer", "Wizard"]
    },
    {
      name: "Otiluke's Freezing Sphere",
      level: 6,
      school: "Evocation",
      castTime: "1 action",
      range: "300 feet",
      components: "V, S, M",
      componentDetails: { material: "a small crystal sphere" },
      duration: "Instantaneous",
      description: "60-foot radius sphere. 10d6 cold damage on failed Con save (half on success). Freezes water in area to depth of 6 inches for 1 minute.",
      damage: "10d6",
      damageType: "cold",
      saveType: "constitution",
      classes: ["Wizard"],
      upcastDamage: "1d6"
    },
    {
      name: "Otto's Irresistible Dance",
      level: 6,
      school: "Enchantment",
      castTime: "1 action",
      range: "30 feet",
      components: "V",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Target begins dancing comically, using all movement to dance in place. Disadvantage on Dex saves, attacks against it have advantage. At end of each turn, Wis save to end.",
      saveType: "wisdom",
      classes: ["Bard", "Wizard"]
    },
    {
      name: "Planar Ally",
      level: 6,
      school: "Conjuration",
      castTime: "10 minutes",
      range: "60 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Beseech otherworldly entity to send celestial, elemental, or fiend. Negotiate for service (100 gp per minute, 1,000 gp per hour, 10,000 gp per day for non-hazardous tasks; double for hazardous).",
      classes: ["Cleric"]
    },
    {
      name: "Programmed Illusion",
      level: 6,
      school: "Illusion",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      componentDetails: { material: "a bit of fleece and jade dust worth at least 25 gp", cost: 25 },
      duration: "Until dispelled",
      description: "Create illusion (up to 30-foot cube) that activates when specific condition occurs. Can include audible, visual, tactile, and olfactory elements. Lasts up to 5 minutes per activation.",
      classes: ["Bard", "Wizard"]
    },
    {
      name: "Sunbeam",
      level: 6,
      school: "Evocation",
      castTime: "1 action",
      range: "Self (60-foot line)",
      components: "V, S, M",
      componentDetails: { material: "a magnifying glass" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "6d8 radiant damage in 60-foot line, 5-foot wide. Con save for half. Undead/oozes have disadvantage. Blinded on failed save. Can use action each turn to create new beam.",
      damage: "6d8",
      damageType: "radiant",
      saveType: "constitution",
      classes: ["Druid", "Sorcerer", "Wizard"]
    },
    {
      name: "Transport via Plants",
      level: 6,
      school: "Conjuration",
      castTime: "1 action",
      range: "10 feet",
      components: "V, S",
      duration: "1 round",
      description: "Create magical link between Large or larger plant within range and another plant of same kind on same plane. Any creature can step into origin and exit from destination.",
      classes: ["Druid"]
    },
    {
      name: "Wall of Ice",
      level: 6,
      school: "Evocation",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      componentDetails: { material: "a small piece of quartz" },
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Create wall (10 panels, 10x10 feet each, or hemisphere up to 10-foot radius). 10d6 cold damage when creature enters wall for first time or starts turn there (Dex save halves).",
      damage: "10d6",
      damageType: "cold",
      saveType: "dexterity",
      classes: ["Wizard"]
    },
    {
      name: "Wall of Thorns",
      level: 6,
      school: "Conjuration",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S, M",
      componentDetails: { material: "a handful of thorns" },
      duration: "Concentration, up to 10 minutes",
      concentration: true,
      description: "Create wall (up to 60 feet long, 10 feet high, 5 feet thick). 7d8 piercing damage when entering wall for first time or starting turn there (Dex save halves). Area is difficult terrain.",
      damage: "7d8",
      damageType: "piercing",
      saveType: "dexterity",
      classes: ["Druid"],
      upcastDamage: "1d8"
    },
    {
      name: "Wind Walk",
      level: 6,
      school: "Transmutation",
      castTime: "1 minute",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "fire and holy water" },
      duration: "8 hours",
      description: "Up to 10 creatures assume gaseous form with flying speed of 300 feet. Takes 1 minute to transform between forms. In gaseous form, can only dash and have resistance to nonmagical weapon damage.",
      classes: ["Druid"]
    },
    {
      name: "Word of Recall",
      level: 6,
      school: "Conjuration",
      castTime: "1 action",
      range: "5 feet",
      components: "V",
      duration: "Instantaneous",
      description: "You and up to 5 willing creatures within 5 feet teleport to previously designated sanctuary (temple, grove, or similar holy place dedicated to your deity).",
      classes: ["Cleric"]
    }
  ],
  7: [ // Level 7
    {
      name: "Delayed Blast Fireball",
      level: 7,
      school: "Evocation",
      castTime: "1 action",
      range: "150 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "12d6 fire damage, +1d6 per turn delayed (max 22d6).",
      damage: "12d6",
      damageType: "fire",
      saveType: "dexterity",
      concentration: true,
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Finger of Death",
      level: 7,
      school: "Necromancy",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "7d8+30 necrotic damage, killed humanoid rises as zombie.",
      damage: "7d8+30",
      damageType: "necrotic",
      saveType: "constitution",
      classes: ["Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Plane Shift",
      level: 7,
      school: "Conjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "Transport up to 8 willing creatures to another plane.",
      saveType: "charisma",
      classes: ["Cleric", "Druid", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Prismatic Spray",
      level: 7,
      school: "Evocation",
      castTime: "1 action",
      range: "Self (60-foot cone)",
      components: "V, S",
      duration: "Instantaneous",
      description: "60-foot cone, random colored rays with various effects.",
      damage: "10d6",
      damageType: "varies",
      saveType: "dexterity",
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Resurrection",
      level: 7,
      school: "Necromancy",
      castTime: "1 hour",
      range: "Touch",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "Restore to life creature dead no longer than 100 years.",
      classes: ["Bard", "Cleric"]
    },
    {
      name: "Teleport",
      level: 7,
      school: "Conjuration",
      castTime: "1 action",
      range: "10 feet",
      components: "V",
      duration: "Instantaneous",
      description: "Instantly transport up to 8 willing creatures to destination you know.",
      classes: ["Bard", "Sorcerer", "Wizard"]
    },
    // [2025-11-25] Phase 3 - Missing 7th level spells from comprehensive PHB audit
    {
      name: "Conjure Celestial",
      level: 7,
      school: "Conjuration",
      castTime: "1 minute",
      range: "90 feet",
      components: "V, S",
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Summon celestial of CR 4 or lower that obeys verbal commands and acts on your turn. Reverts if dropped to 0 HP or spell ends.",
      classes: ["Cleric"],
      upcastEffect: "CR 5 at 9th level."
    },
    {
      name: "Divine Word",
      level: 7,
      school: "Evocation",
      castTime: "1 bonus action",
      range: "30 feet",
      components: "V",
      duration: "Instantaneous",
      description: "Creatures you choose that can hear you make Cha save. Effects based on current HP: 50+ deafened 1 min; 40-49 deafened/blinded 10 min; 30-39 blinded/stunned 1 hour; 20-29 killed instantly. Celestial/elemental/fey/fiend banished for 24 hours.",
      saveType: "charisma",
      classes: ["Cleric"]
    },
    {
      name: "Etherealness",
      level: 7,
      school: "Transmutation",
      castTime: "1 action",
      range: "Self",
      components: "V, S",
      duration: "Up to 8 hours",
      description: "Step into Ethereal Plane. Can see 60 feet into origin plane in gray shades. Can move in any direction. Only affect and be affected by other creatures on Ethereal Plane.",
      classes: ["Bard", "Cleric", "Sorcerer", "Warlock", "Wizard"],
      upcastEffect: "+3 willing creatures per level above 7th."
    },
    {
      name: "Fire Storm",
      level: 7,
      school: "Evocation",
      castTime: "1 action",
      range: "150 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Storm of fire in area consisting of up to 10 10-foot cubes (you arrange cubes). 7d10 fire damage on failed Dex save (half on success). Fire spreads around corners. Ignites flammable objects not being worn/carried.",
      damage: "7d10",
      damageType: "fire",
      saveType: "dexterity",
      classes: ["Cleric", "Druid", "Sorcerer"]
    },
    {
      name: "Forcecage",
      level: 7,
      school: "Evocation",
      castTime: "1 action",
      range: "100 feet",
      components: "V, S, M",
      componentDetails: { material: "ruby dust worth 1,500 gp", cost: 1500 },
      duration: "1 hour",
      description: "Create 10-foot cube of force bars or 20-foot solid cube. Nothing can pass through (spells can). Creatures trapped can attempt to teleport (Cha save to succeed).",
      saveType: "charisma",
      classes: ["Bard", "Warlock", "Wizard"]
    },
    {
      name: "Mirage Arcane",
      level: 7,
      school: "Illusion",
      castTime: "10 minutes",
      range: "Sight",
      components: "V, S",
      duration: "10 days",
      description: "Make terrain in 1-mile square look, sound, smell, and feel like different terrain. Illusion includes audible, visual, tactile, and olfactory elements. Physical interaction doesn't reveal it as illusion.",
      classes: ["Bard", "Druid", "Wizard"]
    },
    {
      name: "Mordenkainen's Magnificent Mansion",
      level: 7,
      school: "Conjuration",
      castTime: "1 minute",
      range: "300 feet",
      components: "V, S, M",
      componentDetails: { material: "a miniature portal carved from ivory, a small piece of polished marble, and a tiny silver spoon, each item worth at least 5 gp", cost: 15 },
      duration: "24 hours",
      description: "Conjure extradimensional dwelling with shimmering portal. Interior has entrance hall, banquet hall, dozens of chambers, and 100 servants. Food from mansion satisfies hunger without nutrients.",
      classes: ["Bard", "Wizard"]
    },
    {
      name: "Mordenkainen's Sword",
      level: 7,
      school: "Evocation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      componentDetails: { material: "a miniature platinum sword with a grip and pommel of copper and zinc, worth 250 gp", cost: 250 },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Create sword-shaped plane of force. As bonus action, move sword up to 20 feet and make melee spell attack against creature within 5 feet: 3d10 force damage.",
      damage: "3d10",
      damageType: "force",
      classes: ["Bard", "Wizard"]
    },
    {
      name: "Project Image",
      level: 7,
      school: "Illusion",
      castTime: "1 action",
      range: "500 miles",
      components: "V, S, M",
      componentDetails: { material: "a small replica of you made from materials worth at least 5 gp", cost: 5 },
      duration: "Concentration, up to 1 day",
      concentration: true,
      description: "Create illusory copy of yourself at location within range. Looks perfectly real, can make it speak, gesture, and behave as you direct. Can see/hear through it. Appears translucent if touched.",
      classes: ["Bard", "Wizard"]
    },
    {
      name: "Regenerate",
      level: 7,
      school: "Transmutation",
      castTime: "1 minute",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a prayer wheel and holy water" },
      duration: "1 hour",
      description: "Touch creature to regain 4d8+15 HP instantly. For duration, regain 1 HP at start of each turn (10 HP per minute). Severed body parts regrow after 2 minutes.",
      healing: "4d8+15",
      classes: ["Bard", "Cleric", "Druid"]
    },
    {
      name: "Reverse Gravity",
      level: 7,
      school: "Transmutation",
      castTime: "1 action",
      range: "100 feet",
      components: "V, S, M",
      componentDetails: { material: "a lodestone and iron filings" },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Reverse gravity in 50-foot radius, 100-foot high cylinder. Creatures make Dex save to grab fixed object or fall upward 100 feet, taking 10d6 bludgeoning when hitting ceiling.",
      damage: "10d6",
      damageType: "bludgeoning",
      saveType: "dexterity",
      classes: ["Druid", "Sorcerer", "Wizard"]
    },
    {
      name: "Sequester",
      level: 7,
      school: "Transmutation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a powder composed of diamond, emerald, ruby, and sapphire dust worth at least 5,000 gp, which the spell consumes", consumed: true, cost: 5000 },
      duration: "Until dispelled",
      description: "Willing creature or object becomes invisible and enters state of suspended animation. Immune to damage. Can specify condition that ends spell (or dismiss as action).",
      classes: ["Wizard"]
    },
    {
      name: "Simulacrum",
      level: 7,
      school: "Illusion",
      castTime: "12 hours",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "snow or ice in quantities sufficient to made a life-size copy of the creature, some hair, fingernail clippings, or other piece of creature's body, and powdered ruby worth 1,500 gp", consumed: true, cost: 1500 },
      duration: "Until dispelled",
      description: "Create illusory duplicate of beast or humanoid within range. Has half the creature's HP maximum and is formed without equipment. Obeys your spoken commands but can't learn or become more powerful.",
      classes: ["Wizard"]
    },
    {
      name: "Symbol",
      level: 7,
      school: "Abjuration",
      castTime: "1 minute",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "mercury, phosphorus, and powdered diamond and opal with a total value of at least 1,000 gp, which the spell consumes", consumed: true, cost: 1000 },
      duration: "Until dispelled or triggered",
      description: "Inscribe harmful glyph on surface or in object. When triggered (creature comes within 60 feet), choose effect: Death (10d10 necrotic), Discord, Fear, Hopelessness, Insanity, Pain, Sleep, Stunning.",
      damage: "10d10",
      damageType: "necrotic",
      saveType: "constitution",
      classes: ["Bard", "Cleric", "Wizard"]
    }
  ],
  8: [ // Level 8
    {
      name: "Dominate Monster",
      level: 8,
      school: "Enchantment",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Concentration, up to 1 hour",
      description: "Creature must succeed on Wisdom save or be charmed and controlled.",
      saveType: "wisdom",
      concentration: true,
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Earthquake",
      level: 8,
      school: "Evocation",
      castTime: "1 action",
      range: "500 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "100-foot radius seismic disturbance.",
      saveType: "dexterity",
      concentration: true,
      classes: ["Cleric", "Druid", "Sorcerer"]
    },
    {
      name: "Incendiary Cloud",
      level: 8,
      school: "Conjuration",
      castTime: "1 action",
      range: "150 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      description: "20-foot radius cloud, 10d8 fire damage.",
      damage: "10d8",
      damageType: "fire",
      saveType: "dexterity",
      concentration: true,
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Maze",
      level: 8,
      school: "Conjuration",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Concentration, up to 10 minutes",
      description: "Banish creature to labyrinthine demiplane.",
      concentration: true,
      classes: ["Wizard"]
    },
    {
      name: "Power Word Stun",
      level: 8,
      school: "Enchantment",
      castTime: "1 action",
      range: "60 feet",
      components: "V",
      duration: "Instantaneous",
      description: "Creature with 150 HP or fewer is stunned.",
      saveType: "constitution",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Sunburst",
      level: 8,
      school: "Evocation",
      castTime: "1 action",
      range: "150 feet",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "60-foot radius, 12d6 radiant damage and blindness.",
      damage: "12d6",
      damageType: "radiant",
      saveType: "constitution",
      classes: ["Druid", "Sorcerer", "Wizard"]
    },
    // [2025-11-25] Phase 3 - Missing 8th level spells from comprehensive PHB audit
    {
      name: "Antimagic Field",
      level: 8,
      school: "Abjuration",
      castTime: "1 action",
      range: "Self (10-foot-radius sphere)",
      components: "V, S, M",
      componentDetails: { material: "a pinch of powdered iron or iron filings" },
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "10-foot radius sphere of antimagic. Spells and magical effects suppressed within area. Magic items become mundane. Summoned creatures disappear.",
      classes: ["Cleric", "Wizard"]
    },
    {
      name: "Antipathy/Sympathy",
      level: 8,
      school: "Enchantment",
      castTime: "1 hour",
      range: "60 feet",
      components: "V, S, M",
      componentDetails: { material: "either a lump of alum soaked in vinegar for antipathy or a drop of honey for sympathy" },
      duration: "10 days",
      description: "Target object, creature, or area becomes attractive (sympathy) or repulsive (antipathy) to specified creature type. Wis save to resist, affected creatures must move toward (sympathy) or away from (antipathy) target.",
      saveType: "wisdom",
      classes: ["Druid", "Wizard"]
    },
    {
      name: "Clone",
      level: 8,
      school: "Necromancy",
      castTime: "1 hour",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a diamond worth at least 1,000 gp and at least 1 cubic inch of flesh of the creature that is to be cloned, which the spell consumes, and a vessel worth at least 2,000 gp that has a sealable lid and is large enough to hold a Medium creature", consumed: true, cost: 3000 },
      duration: "Instantaneous",
      description: "Create inert duplicate of living creature. Clone matures after 120 days. If original dies, soul transfers to clone if free and willing. Clone is same age as original when cast.",
      classes: ["Wizard"]
    },
    {
      name: "Control Weather",
      level: 8,
      school: "Transmutation",
      castTime: "10 minutes",
      range: "Self (5-mile radius)",
      components: "V, S, M",
      componentDetails: { material: "burning incense and bits of earth and wood mixed in water" },
      duration: "Concentration, up to 8 hours",
      concentration: true,
      description: "Control weather in 5-mile radius. Change precipitation, temperature, and wind. Each change takes 1d4 × 10 minutes. You specify target conditions and weather moves toward it.",
      classes: ["Cleric", "Druid", "Wizard"]
    },
    {
      name: "Demiplane",
      level: 8,
      school: "Conjuration",
      castTime: "1 action",
      range: "60 feet",
      components: "S",
      duration: "1 hour",
      description: "Create shadowy door on flat solid surface. Door leads to empty 30-foot cube demiplane. When spell ends, door disappears and creatures inside are trapped until door is created again.",
      classes: ["Warlock", "Wizard"]
    },
    {
      name: "Feeblemind",
      level: 8,
      school: "Enchantment",
      castTime: "1 action",
      range: "150 feet",
      components: "V, S, M",
      componentDetails: { material: "a handful of clay, crystal, glass, or mineral spheres" },
      duration: "Instantaneous",
      description: "Target takes 4d6 psychic damage and makes Int save. On failure, Int and Cha become 1. Can't cast spells, use items, understand language, or communicate. Save every 30 days to end.",
      damage: "4d6",
      damageType: "psychic",
      saveType: "intelligence",
      classes: ["Bard", "Druid", "Warlock", "Wizard"]
    },
    {
      name: "Glibness",
      level: 8,
      school: "Transmutation",
      castTime: "1 action",
      range: "Self",
      components: "V",
      duration: "1 hour",
      description: "When you make a Charisma check, you can replace any roll with a 15. Additionally, magic that would determine if you're telling the truth indicates you're being truthful.",
      classes: ["Bard", "Warlock"]
    },
    {
      name: "Holy Aura",
      level: 8,
      school: "Abjuration",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "a tiny reliquary worth at least 1,000 gp containing a sacred relic", cost: 1000 },
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Divine light in 30-foot radius. Creatures you choose have advantage on saves, attacks against them have disadvantage. Fiend or undead hitting protected creature makes Con save or is blinded.",
      saveType: "constitution",
      classes: ["Cleric"]
    },
    {
      name: "Mind Blank",
      level: 8,
      school: "Abjuration",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "24 hours",
      description: "Touched creature is immune to psychic damage, any effect that would sense its emotions or read its thoughts, divination spells, and the charmed condition.",
      classes: ["Bard", "Wizard"]
    },
    {
      name: "Telepathy",
      level: 8,
      school: "Evocation",
      castTime: "1 action",
      range: "Unlimited",
      components: "V, S, M",
      componentDetails: { material: "a pair of linked silver rings" },
      duration: "24 hours",
      description: "Create telepathic link with willing creature you're familiar with. Can communicate telepathically regardless of distance. Creature must be on same plane.",
      classes: ["Wizard"]
    },
    {
      name: "Tsunami",
      level: 8,
      school: "Conjuration",
      castTime: "1 minute",
      range: "Sight",
      components: "V, S",
      duration: "Concentration, up to 6 rounds",
      concentration: true,
      description: "Wall of water up to 300 feet long, 300 feet high. 6d10 bludgeoning damage on failed Str save. Wall moves 50 feet away from you each round, height decreasing by 50 feet per round.",
      damage: "6d10",
      damageType: "bludgeoning",
      saveType: "strength",
      classes: ["Druid"]
    },
    {
      name: "Animal Shapes",
      level: 8,
      school: "Transmutation",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S",
      duration: "Concentration, up to 24 hours",
      concentration: true,
      description: "Transform willing creatures you can see within range into beasts of CR 4 or lower. Each target assumes beast form of your choice. Targets retain their Intelligence, Wisdom, and Charisma.",
      classes: ["Druid"]
    },
    {
      name: "Abi-Dalzim's Horrid Wilting",
      level: 8,
      school: "Necromancy",
      castTime: "1 action",
      range: "150 feet",
      components: "V, S, M",
      componentDetails: { material: "a bit of sponge" },
      duration: "Instantaneous",
      description: "Creatures in 30-foot cube take 12d8 necrotic damage, Con save for half. Plants and water elementals have disadvantage. Plant creatures take maximum damage. Nonmagical plants wither and die.",
      damage: "12d8",
      damageType: "necrotic",
      saveType: "constitution",
      classes: ["Sorcerer", "Wizard"]
    }
  ],
  9: [ // Level 9
    {
      name: "Gate",
      level: 9,
      school: "Conjuration",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S, M",
      duration: "Concentration, up to 1 minute",
      description: "Create portal to another plane or summon creature from another plane.",
      concentration: true,
      classes: ["Cleric", "Sorcerer", "Wizard"]
    },
    {
      name: "Meteor Swarm",
      level: 9,
      school: "Evocation",
      castTime: "1 action",
      range: "1 mile",
      components: "V, S",
      duration: "Instantaneous",
      description: "Four 40-foot radius spheres, 20d6 fire + 20d6 bludgeoning damage.",
      damage: "20d6+20d6",
      damageType: "fire/bludgeoning",
      saveType: "dexterity",
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "Power Word Kill",
      level: 9,
      school: "Enchantment",
      castTime: "1 action",
      range: "60 feet",
      components: "V",
      duration: "Instantaneous",
      description: "Creature with 100 HP or fewer dies instantly.",
      classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
    },
    {
      name: "Prismatic Wall",
      level: 9,
      school: "Abjuration",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "10 minutes",
      description: "Create wall with seven layers, each with different properties.",
      classes: ["Wizard"]
    },
    {
      name: "Time Stop",
      level: 9,
      school: "Transmutation",
      castTime: "1 action",
      range: "Self",
      components: "V",
      duration: "Instantaneous",
      description: "Stop time for everyone but yourself for 1d4+1 turns.",
      classes: ["Sorcerer", "Wizard"]
    },
    {
      name: "True Resurrection",
      level: 9,
      school: "Necromancy",
      castTime: "1 hour",
      range: "Touch",
      components: "V, S, M",
      duration: "Instantaneous",
      description: "Restore to life creature dead no longer than 200 years, creates new body if needed.",
      classes: ["Cleric", "Druid"]
    },
    {
      name: "Wish",
      level: 9,
      school: "Conjuration",
      castTime: "1 action",
      range: "Self",
      components: "V",
      duration: "Instantaneous",
      description: "Duplicate any spell of 8th level or lower, or alter reality itself.",
      classes: ["Sorcerer", "Wizard"]
    },
    // [2025-11-25] Phase 3 - Missing 9th level spells from comprehensive PHB audit
    {
      name: "Astral Projection",
      level: 9,
      school: "Necromancy",
      castTime: "1 hour",
      range: "10 feet",
      components: "V, S, M",
      componentDetails: { material: "for each creature you affect, you must provide one jacinth worth at least 1,000 gp and one ornately carved bar of silver worth at least 100 gp, all of which the spell consumes", consumed: true, cost: 1100 },
      duration: "Special",
      description: "Project astral bodies of you and up to 8 willing creatures onto Astral Plane. Silver cord connects to material body. If cord is severed, body and soul are separated. Can travel to other planes.",
      classes: ["Cleric", "Warlock", "Wizard"]
    },
    {
      name: "Foresight",
      level: 9,
      school: "Divination",
      castTime: "1 minute",
      range: "Touch",
      components: "V, S, M",
      componentDetails: { material: "a hummingbird feather" },
      duration: "8 hours",
      description: "Touch creature to grant it limited ability to see the future. Target can't be surprised, has advantage on attack rolls, ability checks, and saving throws. Other creatures have disadvantage on attacks against target.",
      classes: ["Bard", "Druid", "Warlock", "Wizard"]
    },
    {
      name: "Imprisonment",
      level: 9,
      school: "Abjuration",
      castTime: "1 minute",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "a vellum depiction or a carved statuette in the likeness of the target, and a special component that varies according to the version of the spell you choose, worth at least 500 gp per Hit Die of the target", cost: 500 },
      duration: "Until dispelled",
      description: "Create magical restraint to hold creature. Choose form: Burial (entombed), Chaining (held by chains), Hedged Prison (confined area), Minimus Containment (shrunk into gem), or Slumber (asleep).",
      saveType: "wisdom",
      classes: ["Warlock", "Wizard"]
    },
    {
      name: "Mass Heal",
      level: 9,
      school: "Evocation",
      castTime: "1 action",
      range: "60 feet",
      components: "V, S",
      duration: "Instantaneous",
      description: "Restore up to 700 HP, divided as you choose among creatures within range. Also ends blindness, deafness, and any diseases affecting targets. Has no effect on undead or constructs.",
      healing: "700",
      spellType: "healing",
      classes: ["Cleric"]
    },
    {
      name: "Power Word Heal",
      level: 9,
      school: "Evocation",
      castTime: "1 action",
      range: "Touch",
      components: "V, S",
      duration: "Instantaneous",
      description: "Touch creature to restore all its hit points. Also ends charmed, frightened, paralyzed, or stunned conditions. Creature can use reaction to stand up.",
      healing: "max",
      spellType: "healing",
      classes: ["Bard"]
    },
    {
      name: "Shapechange",
      level: 9,
      school: "Transmutation",
      castTime: "1 action",
      range: "Self",
      components: "V, S, M",
      componentDetails: { material: "a jade circlet worth at least 1,500 gp, which you must place on your head before you cast the spell", cost: 1500 },
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Assume form of different creature (CR equal or less than level). Gain physical stats and abilities but retain mental stats, class features, and personality. Can use action to change form.",
      classes: ["Druid", "Wizard"]
    },
    {
      name: "Storm of Vengeance",
      level: 9,
      school: "Conjuration",
      castTime: "1 action",
      range: "Sight",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "360-foot radius storm. Each round has different effect: Round 1 (2d6 thunder, deafened), Round 2 (1d6 acid rain), Rounds 3-4 (6d6 lightning bolts), Rounds 5-10 (2d6 bludgeoning + difficult terrain).",
      damage: "2d6",
      damageType: "thunder",
      saveType: "constitution",
      classes: ["Druid"]
    },
    {
      name: "True Polymorph",
      level: 9,
      school: "Transmutation",
      castTime: "1 action",
      range: "30 feet",
      components: "V, S, M",
      componentDetails: { material: "a drop of mercury, a dollop of gum arabic, and a wisp of smoke" },
      duration: "Concentration, up to 1 hour",
      concentration: true,
      description: "Transform creature into different creature (CR equal or less than level) or nonmagical object, or object into creature. Permanent if you concentrate for full duration.",
      saveType: "wisdom",
      classes: ["Bard", "Warlock", "Wizard"]
    },
    {
      name: "Weird",
      level: 9,
      school: "Illusion",
      castTime: "1 action",
      range: "120 feet",
      components: "V, S",
      duration: "Concentration, up to 1 minute",
      concentration: true,
      description: "Each creature in 30-foot radius sphere makes Wis save or is frightened. At end of each turn, frightened creature makes Wis save or takes 4d10 psychic damage. On success, spell ends for that creature.",
      damage: "4d10",
      damageType: "psychic",
      saveType: "wisdom",
      classes: ["Wizard"]
    }
  ]
};

// Function to get spells by class
export function getSpellsByClass(className, level = null) {
  const spells = [];
  
  // If no className provided, return all spells
  if (!className) {
    Object.keys(SRD_SPELLS).forEach(spellLevel => {
      if (level === null || parseInt(spellLevel) === level) {
        SRD_SPELLS[spellLevel].forEach(spell => {
          spells.push({
            ...spell,
            level: parseInt(spellLevel)
          });
        });
      }
    });
    return spells;
  }
  
  // Capitalize the class name for comparison
  const capitalizedClass = className.charAt(0).toUpperCase() + className.slice(1).toLowerCase();
  
  Object.keys(SRD_SPELLS).forEach(spellLevel => {
    if (level === null || parseInt(spellLevel) === level) {
      SRD_SPELLS[spellLevel].forEach(spell => {
        if (spell.classes && spell.classes.some(c => 
          c.toLowerCase() === className.toLowerCase() || 
          c === capitalizedClass
        )) {
          spells.push({
            ...spell,
            level: parseInt(spellLevel)
          });
        }
      });
    }
  });
  
  return spells;
}

// Function to calculate spell slots based on class and level
export function calculateSpellSlots(className, characterLevel) {
  const spellSlots = {
    1: { max: 0, used: 0 },
    2: { max: 0, used: 0 },
    3: { max: 0, used: 0 },
    4: { max: 0, used: 0 },
    5: { max: 0, used: 0 },
    6: { max: 0, used: 0 },
    7: { max: 0, used: 0 },
    8: { max: 0, used: 0 },
    9: { max: 0, used: 0 }
  };

  // Full casters (Bard, Cleric, Druid, Sorcerer, Wizard)
  const fullCasterSlots = [
    [0,0,0,0,0,0,0,0,0], // Level 0 (not used)
    [2,0,0,0,0,0,0,0,0], // Level 1
    [3,0,0,0,0,0,0,0,0], // Level 2
    [4,2,0,0,0,0,0,0,0], // Level 3
    [4,3,0,0,0,0,0,0,0], // Level 4
    [4,3,2,0,0,0,0,0,0], // Level 5
    [4,3,3,0,0,0,0,0,0], // Level 6
    [4,3,3,1,0,0,0,0,0], // Level 7
    [4,3,3,2,0,0,0,0,0], // Level 8
    [4,3,3,3,1,0,0,0,0], // Level 9
    [4,3,3,3,2,0,0,0,0], // Level 10
    [4,3,3,3,2,1,0,0,0], // Level 11
    [4,3,3,3,2,1,0,0,0], // Level 12
    [4,3,3,3,2,1,1,0,0], // Level 13
    [4,3,3,3,2,1,1,0,0], // Level 14
    [4,3,3,3,2,1,1,1,0], // Level 15
    [4,3,3,3,2,1,1,1,0], // Level 16
    [4,3,3,3,2,1,1,1,1], // Level 17
    [4,3,3,3,3,1,1,1,1], // Level 18
    [4,3,3,3,3,2,1,1,1], // Level 19
    [4,3,3,3,3,2,2,1,1]  // Level 20
  ];

  // Half casters (Paladin, Ranger)
  const halfCasterSlots = [
    [0,0,0,0,0,0,0,0,0], // Level 0-1
    [0,0,0,0,0,0,0,0,0], // Level 1
    [2,0,0,0,0,0,0,0,0], // Level 2
    [3,0,0,0,0,0,0,0,0], // Level 3
    [3,0,0,0,0,0,0,0,0], // Level 4
    [4,2,0,0,0,0,0,0,0], // Level 5
    [4,2,0,0,0,0,0,0,0], // Level 6
    [4,3,0,0,0,0,0,0,0], // Level 7
    [4,3,0,0,0,0,0,0,0], // Level 8
    [4,3,2,0,0,0,0,0,0], // Level 9
    [4,3,2,0,0,0,0,0,0], // Level 10
    [4,3,3,0,0,0,0,0,0], // Level 11
    [4,3,3,0,0,0,0,0,0], // Level 12
    [4,3,3,1,0,0,0,0,0], // Level 13
    [4,3,3,1,0,0,0,0,0], // Level 14
    [4,3,3,2,0,0,0,0,0], // Level 15
    [4,3,3,2,0,0,0,0,0], // Level 16
    [4,3,3,3,1,0,0,0,0], // Level 17
    [4,3,3,3,1,0,0,0,0], // Level 18
    [4,3,3,3,2,0,0,0,0], // Level 19
    [4,3,3,3,2,0,0,0,0]  // Level 20
  ];

  // Warlock (Pact Magic)
  const warlockSlots = [
    [0,0,0,0,0,0,0,0,0], // Level 0
    [1,0,0,0,0,0,0,0,0], // Level 1 - 1 slot, 1st level
    [2,0,0,0,0,0,0,0,0], // Level 2 - 2 slots, 1st level
    [0,2,0,0,0,0,0,0,0], // Level 3 - 2 slots, 2nd level
    [0,2,0,0,0,0,0,0,0], // Level 4
    [0,0,2,0,0,0,0,0,0], // Level 5 - 2 slots, 3rd level
    [0,0,2,0,0,0,0,0,0], // Level 6
    [0,0,0,2,0,0,0,0,0], // Level 7 - 2 slots, 4th level
    [0,0,0,2,0,0,0,0,0], // Level 8
    [0,0,0,0,2,0,0,0,0], // Level 9 - 2 slots, 5th level
    [0,0,0,0,2,0,0,0,0], // Level 10
    [0,0,0,0,3,0,0,0,0], // Level 11 - 3 slots, 5th level
    [0,0,0,0,3,0,0,0,0], // Level 12
    [0,0,0,0,3,0,0,0,0], // Level 13
    [0,0,0,0,3,0,0,0,0], // Level 14
    [0,0,0,0,3,0,0,0,0], // Level 15
    [0,0,0,0,3,0,0,0,0], // Level 16
    [0,0,0,0,4,0,0,0,0], // Level 17 - 4 slots, 5th level
    [0,0,0,0,4,0,0,0,0], // Level 18
    [0,0,0,0,4,0,0,0,0], // Level 19
    [0,0,0,0,4,0,0,0,0]  // Level 20
  ];

  let slots = null;
  
  // [v1.0]: Property-based caster type detection (no hardcoded class name arrays)
  let casterType;
  try {
    const { getCasterType } = require('../utils/contentResolver');
    casterType = getCasterType(className);
  } catch (e) {
    // Fallback if contentResolver not available
    casterType = null;
  }

  if (casterType === 'full') {
    slots = fullCasterSlots[Math.min(characterLevel, 20)];
  } else if (casterType === 'half') {
    slots = halfCasterSlots[Math.min(characterLevel, 20)];
  } else if (casterType === 'pact') {
    slots = warlockSlots[Math.min(characterLevel, 20)];
  }

  if (slots) {
    for (let i = 0; i < 9; i++) {
      spellSlots[i + 1].max = slots[i];
    }
  }

  return spellSlots;
}

// Wizard spellbook rules
export const WIZARD_SPELLBOOK_RULES = {
  startingSpells: 6, // 6 1st-level spells at character creation
  spellsPerLevel: 2, // 2 spells added per wizard level
  copySpellCost: (spellLevel) => spellLevel * 50, // 50gp per spell level
  copySpellTime: (spellLevel) => spellLevel * 2, // 2 hours per spell level
  preparedSpells: (wizardLevel, intModifier) => Math.max(1, wizardLevel + intModifier),
  ritualCasting: true, // Can cast ritual spells without preparing if in spellbook
  spellbookReplacementCost: 50, // 50gp per spell level to replace lost spellbook
};